CustomTC.define('modules/player',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/events', 'modules/player-ui', 'modules/language', 'modules/chapters/chapter', 'modules/logger'], function(util, core, mainConfig, constants, options, events, playerUI, language, chapter, logger) {
    return {
        config:{},
        touchcastID: '',
        autoplay: 0,
        loop: 0,
        end: 1,
        pdfEnhancements: 1,
        startTime: 0,
        btnPlay: 1,
        btnVolume: 1,
        tcProgressBar: 1,
        tcPlayerTime: 1,
        btnChat: 0,
        btnReCast: 1,
        btnComment: 1,
        btnSettings: 1,
        btnTranscriptions: 1,
        btnInfo: 1,
        btnShare: 1,
        btnFullScreen: 1,
        infoBoxShareViewsRecastCounts: 1,
        infoBoxBookmarkButton: 1,
        infoBoxFollowButton: 1,
        infoBoxFlagButton: 1,
        allowAjax: 1,
        changeOriginal: 0,
        insideChange: 0,
        changingTC: 0,
        backToOriginal: 0,
        breadCrumbVideoInfo: [],
        breadCrumbLevel: 0,
        interactiveTip: 1,
        directLoad: 0,
        hls: '',
        hlsDecimal: '',
        hlsBaseUrlActions: '',
        hlsData: '',
        hlsInitiated: 0,
        chatInited: 0,
        tcInside: 0,
        btnsInitiated: 0,
        initialShareBtn: 0,
        initialCommentBtn: 0,
        initialRecastBtn: 0,
        initialInfoBtn: 0,
        originalChatButtonState: 0,
        hlsCurrentSegment: '',
        lastSegmentReceived: '',
        //hlsCurrentTime: 0,
        nonInteractiveShown: 0,
        notSupportedShown: 0,
        calledHostForPauseFinish: 0,
        firstTCLevel: -1,
        segmentEnd: [],
        //hlsLastFailedDuration: '',
        //hlsCurrentState: '',
        hlsStats: {},
        hlsStatsData: {},
        hlsUUID: '',
        qualityFile: '',
        tsArray: [],
        safariAjax: 0,
        previousState: '',
        liveStateCalled: 0,

        init: function(config) {
            if (typeof config.domain !== 'undefined' && config.domain !== '')
                mainConfig.domain = config.domain;

            if (util.isiPad() || util.isiPhone() || util.isiPod()) {
                core.addClass(core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + ', .' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + ', .' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + ', .' + constants.CSS_TOUCHCAST_PROGRESS_PANEL + ''), constants.CSS_TOUCHCAST_NO_VOLUME_FULLSCREEN);
            }
            for (var i in config) {
                switch (i) {
                    case 'touchcastID':
                        this.setTouchCastId(config.touchcastID);
                        break;
                    case 'skincolor':
                        options.setSkinColor(config.skincolor);
                        break;
                    case 'autoplay':
                        if (this.isAutoPlayDisabledDevice()) {
                            this.setAutoPlay(0);
                            options.setAutoPlay(0);
                        } else {
                            this.setAutoPlay(parseInt(config.autoplay));
                            options.setAutoPlay(parseInt(config.autoplay));
                        }
                        break;
                    case 'end':
                        this.setEndScreen(parseInt(config.end));
                        break;
                    case 'pdfEnhancements':
                        this.setPdfEnhancements(parseInt(config.pdfEnhancements));
                        break;
                    case 'startTime':
                        this.setStartTime(parseFloat(config.startTime));
                        break;
                    case 'btnPlay':
                        this.setPlayButtonState(parseInt(config.btnPlay));
                        break;
                    case 'btnVolume':
                        this.setVolumeButtonState(parseInt(config.btnVolume));
                        break;
                    case 'tcProgressBar':
                        this.setProgressBarState(parseInt(config.tcProgressBar));
                        break;
                    case 'tcPlayerTime':
                        this.setPlayerTimeState(parseInt(config.tcPlayerTime));
                        break;
                    case 'btnReCast':
                        this.setRecastButtonState(parseInt(config.btnReCast));
                        this.initialRecastBtn = parseInt(config.btnReCast);
                        break;
                    case 'btnComment':
                        this.setCommentButtonState(parseInt(config.btnComment));
                        this.initialCommentBtn = parseInt(config.btnComment);
                        break;
                    case 'btnInfo':
                        this.setInfoButtonState(parseInt(config.btnInfo));
                        this.initialInfoBtn = parseInt(config.btnInfo);
                        break;
                    case 'btnShare':
                        this.setShareButtonState(parseInt(config.btnShare));
                        this.initialShareBtn = parseInt(config.btnShare);
                        break;
                    case 'btnFullScreen':
                        this.setFullScreenButtonState(parseInt(config.btnFullScreen));
                        break;
                    case 'infoBoxShareViewsRecastCounts':
                        this.setInfoBoxCountersState(parseInt(config.infoBoxShareViewsRecastCounts));
                        break;
                    case 'infoBoxBookmarkButton':
                        this.setInfoBoxBookmarkButtonState(parseInt(config.infoBoxBookmarkButton));
                        break;
                    case 'infoBoxFollowButton':
                        this.setInfoBoxFollowButtonState(parseInt(config.infoBoxFollowButton));
                        break;
                    case 'infoBoxFlagButton':
                        this.setInfoBoxFlagButtonState(parseInt(config.infoBoxFlagButton));
                        break;
                    case 'allowAjax':
                        this.setAjaxAllowedState(parseInt(config.allowAjax));
                        break;
                    case 'cacheSkip':
                        options.setCacheSkip(parseInt(config.cacheSkip));
                        break;
                    case 'controlsColor':
                        options.setControlsColor(config.controlsColor);
                        break;
                    case 'controlsDividerColor':
                        options.setControlsDividerColor(config.controlsDividerColor);
                        break;
                    case 'playerBackgroundColor':
                        options.setPlayerBackgroundColor(config.playerBackgroundColor);
                        break;
                    case 'progressUpdateColor':
                        options.setProgressUpdateColor(config.progressUpdateColor);
                        break;
                    case 'subtitlesBackgroundColor':
                        options.setSubtitlesBackgroundColor(config.subtitlesBackgroundColor);
                        break;
                    case 'subtitlesTextColor':
                        options.setSubtitlesTextColor(config.subtitlesTextColor);
                        break;
                    case 'iPhonePlayTip':
                        options.setiPhonePlayTip(config.iPhonePlayTip);
                        break;
                    case 'disableTranscription':
                        options.setDisableTranscription(config.disableTranscription);
                        break;
                    case 'interactiveTip':
                        options.setInteractiveTip(config.interactiveTip);
                        break;
                    case 'mainPlayButton':
                        options.setMainPlayButton(config.mainPlayButton);
                        break;
                    case 'mainPlayButtonPosition':
                        options.setMainPlayButtonPosition(config.mainPlayButtonPosition);
                        break;
                    case 'hls':
                        this.setHlsSource(config.hls);
                        options.setHls(true);
                        break;
                    case 'enableChatSound':
                        options.setEnableDisableChatSound(config.enableChatSound);
                        break;
                    case 'enableThumbsSound':
                        options.setEnableDisableThumbsSound(config.enableThumbsSound);
                        break;
                    case 'enableSearch':
                        options.setEnableDisableSearch(config.enableSearch);
                        break;
                    case 'api_url':
                        options.setApiUrl(config.api_url);
                        break;
                    case 'api_session':
                        options.setApiSession(config.api_session);
                        break;
                    case 'defaultSubtitle':
                        options.setDefaultSubtitle(config.defaultSubtitle);
                        break;
                    case 'livestreamAssetUrl':
                        options.setLivestreamAssetUrl(config.livestreamAssetUrl);
                        break;
                    case 'tclanguage':
                        language.setLanguage(config.tclanguage);
                        options.setFollowRedirectConfirmationMsg(config.tclanguage.video_follow_popup_msg);
                        options.setUnfollowRedirectConfirmationMsg(config.tclanguage.video_unFollow_popup_msg);
                        options.setBookmarkRedirectConfirmationMsg(config.tclanguage.video_bookmark_popup_msg);
                        options.setUnbookmarkRedirectConfirmationMsg(config.tclanguage.video_remove_bookmark_msg);
                        break;
                    default:
                        break;
                }
            }
            if (this.isAjaxAllowed() !== 1) {
                this.setRecastButtonState(0);
                this.initialRecastBtn = 0;
                this.setCommentButtonState(0);
                this.initialCommentBtn = 0;
                this.setInfoBoxCountersState(0);
                this.setInfoBoxBookmarkButtonState(0);
                this.setInfoBoxFollowButtonState(0);
                this.setInfoBoxFlagButtonState(0);
            }
            playerUI.init(config);
            if (util.getIEVersion() <= 10)
                this.setFullScreenButtonState(0);
            options.setFlashPlayerImg(mainConfig.getFlashPlayerBtn);
            options.setDefaultAvatarImg(mainConfig.defaultAvatar);
            if (typeof(User) !== 'undefined') {
                options.setUser(User);
            }
            if (typeof(tcPlayerLanguageObj) !== 'undefined') {
                language.setLanguage(tcPlayerLanguageObj);
                options.setFollowRedirectConfirmationMsg(tcPlayerLanguageObj.video_follow_popup_msg);
                options.setUnfollowRedirectConfirmationMsg(tcPlayerLanguageObj.video_unFollow_popup_msg);
                options.setBookmarkRedirectConfirmationMsg(tcPlayerLanguageObj.video_bookmark_popup_msg);
                options.setUnbookmarkRedirectConfirmationMsg(tcPlayerLanguageObj.video_remove_bookmark_msg);
            }
            if (util.getIEVersion() < 9)
                core.prepend(core.init('body'), '<style type="text/css"> .flashiever { width: 300px !important; right: 8px !important; } </style>');
            options.elem = core.init('.' + constants.CSS_TOUCHCAST_PLAYER_ELEMENT + '');
            this.adjustPlayerControls();
            playerUI.initStats(this, config);
            this.config = config;
        },
        resize: function() {
            playerUI._resize();
            // send size and positon to sdk
            TouchCast.InteractiveLayer.setSizeAndPosition({
                'videoAreaWidth': this.getVideoAreaWidth(),
                'videoAreaHeight': this.getVideoAreaHeight(),
                'videoX': this.getVideoAreaX(),
                'videoY': this.getVideoAreaY()
            });
        },
        adjustPlayerControls: function() {
            if (this.getFullScreenButtonState() === 0)
                playerUI.hideFullScreenButton();
            if (this.getProgressBarState() === 0)
                playerUI.hideProgressBar();
            if (this.getPlayerTimeState() === 0)
                playerUI.hideTimecode();
            if (this.getPlayButtonState() === 0)
                playerUI.hidePlayButton();
            if (this.getVolumeButtonState() === 0)
                playerUI.hideVolumeButton();
            if (this.getInfoButtonState() === 0)
                playerUI.hideInfoButton();
            if (this.getCommentButtonState() === 0)
                playerUI.hideCommentButton();
            if (this.getRecastButtonState() === 0)
                playerUI.hideRecastButton();
            if (this.getShareButtonState() === 0)
                playerUI.hideShareButton();

            if (this.getPlayButtonState() === 0 && this.getVolumeButtonState() === 0)
                playerUI.updateProgressPanelLeft(1);
            else if (this.getPlayButtonState() === 0 || this.getVolumeButtonState() === 0)
                playerUI.updateProgressPanelLeft(45);

            if (this.getPlayButtonState() === 0 && this.getVolumeButtonState() === 1)
                playerUI.updateVolumeContainerLeft(0);

            if (this.getInfoButtonState() === 0 && this.getShareButtonState() === 0 && (this.getCommentButtonState() === 0 || this.getFullScreenButtonState() === 0))
                playerUI.updateRecastContainerRight(0);
        },
        hideButtons: function(btns) {
            for (btn in btns) {
                switch (btns[btn]) {
                    case 'fullscreen':
                        playerUI.hideFullScreenButton();
                        break;
                    case 'progressBar':
                        playerUI.hideProgressBar();
                        break;
                    case 'timecode':
                        playerUI.hideTimecode();
                        break;
                    case 'playBtn':
                        playerUI.hidePlayButton();
                        break;
                    case 'volume':
                        playerUI.hideVolumeButton();
                        break;
                    case 'infoBtn':
                        playerUI.hideInfoButton();
                        break;
                    case 'commentBtn':
                        playerUI.hideCommentButton();
                    case 'recastBtn':
                        playerUI.hideRecastButton();
                    case 'shareBtn':
                        playerUI.hideShareButton();
                        break;
                    default:
                        break;
                }
            }
        },
        initTooltip: function() {
            core.tooltipster(core.init('.' + constants.CSS_TOUCHCAST_TOOL_TIP + ''), {
                placement: 'top'
            });
        },
        initDropdown: function() {
            core.on(core.init('.' + constants.CSS_TOUCHCAST_DROPDOWN_TOGGLE + ''), 'touchstart click', function(e) {
                e.preventDefault();
                core.init('.' + constants.CSS_TOUCHCAST_DROPDOWN_TOGGLE + '').dropdown('show');
            });
        },
        loadVideosFromSDK: function(ID) {
            if (ID === parseInt(ID)) {
                TouchCast.Event.subscribe(TouchCast.InteractiveLayer.VIDEOS_PARTIALLY_READY, eventHandler);
                TouchCast.Event.subscribe(TouchCast.InteractiveLayer.VIDEOS_FULLY_READY, eventHandler);
            } else {
                TouchCast.Event.subscribe(TouchCast.InteractiveLayer.VIDEOS_PARTIALLY_READY, eventHandler);
                TouchCast.Event.subscribe(TouchCast.InteractiveLayer.VIDEOS_FULLY_READY, eventHandler);
            }
        },
        hlsListners: function(hls, backToOriginalHls) {
            var self = this;
            hls.on(Hls.Events.MEDIA_ATTACHED, function() {
                if (self.tcInside !== 1) {
                    logger.log('video and hls lib are now bound together !');
                    self.resumeVideo();
                }
            });
            hls.on(Hls.Events.LEVEL_LOADED, function(event, data) {
                if (self.tcInside !== 1) {
                    const parsingDuration = data.stats.tparsed - data.stats.tload;
                    if (self.hlsStats.levelParsed) {
                        self.hlsStatsData.sumLevelParsingMs += parsingDuration;
                    } else {
                        self.hlsStatsData.sumLevelParsingMs = parsingDuration;
                    }
                    self.hlsStats.levelParsed++;
                    self.hlsStats.levelParsingUs = Math.round(1000 * self.hlsStatsData.sumLevelParsingMs / self.hlsStats.levelParsed);
                    options.updateHlsStats(self.hlsStats);
                    options.setTotalDuration(data.details.totalduration);
                    options.setVideoDuration(data.details.totalduration);
                }
            });
            hls.on(Hls.Events.MANIFEST_PARSED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('manifest parsed', data)
                    self.hlsStats = {
                        connectionSpeed: '',
                        bufferHealth: '',
                        bufferSeekOverHole: undefined,
                        bufferNudgeOnStall: undefined,
                        bufferStalledError: undefined,
                        segments: '',
                        segmentLatency: '',
                        segmentProcessing: '',
                        segmentProblems: '',
                        levelNb: data.levels.length,
                        levelParsed: 0,
                        levelParsingUs: 0,
                        levelStart: undefined,
                        autoLevelAvg: 0,
                        autoLevelCappingLast: '',
                        autoLevelCappingMin: '',
                        autoLevelLast: '',
                        autoLevelMin: '',
                        autoLevelMax: '',
                        autoLevelSwitch: 0
                    };
                    options.updateHlsStats(self.hlsStats);
                    if (data.levels[0] && data.levels[0].height && data.levels[0].width) {
                        options.setHlsLevelHeight(data.levels[0].height);
                        options.setHlsLevelWidth(data.levels[0].width);
                        if (data.levels[0].TCSQUARENUMBER) {
                            options.setHlsSquareNumber(data.levels[0].TCSQUARENUMBER);
                            options.setHlsSquareSize(data.levels[0].TCSQUARESIZE);
                        } else {
                            options.setEncodingMechanism('new');
                        }
                        self.resize();
                    } else {
                        options.setEncodingMechanism('new');
                        self.resize();
                    }
                }
            });

            hls.on(Hls.Events.LEVEL_UPDATED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('Updated level with these segments - [' + data.details.startSN + ',' + data.details.endSN + ']', data);
                    if (options.getHlsPlaylistType() === '') {
                        options.setLive(data.details.live);
                        if (data.details.live === true) {
                            self.setLive();
                        } else {
                            self.disableLive();
                        }
                        options.setHlsPlaylistType(data.details.type)
                    }
                    self.hlsStatsData.fragmentLoadStart = data.details.startSN;
                    self.hlsStatsData.fragmentLoadEnd = data.details.endSN;
                }
            });
            hls.on(Hls.Events.FRAG_LOADING, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('Start loading segment - ' + data.frag.sn, data);
                    self.hlsStatsData.fragmentLoadCurrent = data.frag.sn;
                    self.hlsStats.segments = 'Loading ' + self.hlsStatsData.fragmentLoadCurrent + ' [' + self.hlsStatsData.fragmentLoadStart + ' ' + self.hlsStatsData.fragmentLoadEnd + ']';
                    options.updateHlsStats(self.hlsStats);
                }
            });
            hls.on(Hls.Events.FRAG_LOADED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('End loading segment - ' + data.frag.sn, data);
                }
            });
            hls.on(Hls.Events.FRAG_BUFFERED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('End buffering segment - ' + data.frag.sn, data);
                    if (self.previousState === 'paused' && self.liveStateCalled === 0) {
                        self.resumeVideo(function(){
                            interactiveLayerConfig.livestream_handler.reachedState('live');
                            self.liveStateCalled = 1;
                        });
                    }
                }
            });
            hls.on(Hls.Events.ERROR, function(event, data) {
                //logger.log('Error', data);
                if (self.tcInside !== 1) {
                    switch (data.details) {
                        case Hls.ErrorDetails.MANIFEST_LOAD_ERROR:
                            try {
                                logger.log('cannot Load ' + data.context.url + ' HTTP response code:' + data.response.code + ' - ' + data.response.text);
                                if (data.response.code === 0) {
                                    logger.log('Might be CORS issue');
                                }
                            } catch (err) {
                                logger.log('cannot Load ' + data.context.url + ' Reason:Load ' + data.response.text);
                            }
                            break;
                        case Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                            logger.log('timeout while loading manifest - data -', data);
                            break;
                        case Hls.ErrorDetails.MANIFEST_PARSING_ERROR:
                            logger.log('error while parsing manifest - data -', data);
                            break;
                        case Hls.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR:
                            logger.log('error mainifest with incompatible codecs - data -', data);
                            break;
                        case Hls.ErrorDetails.LEVEL_LOAD_ERROR:
                            logger.log('error while loading level playlist - data -', data);
                            break;
                        case Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                            logger.log('timeout while loading level playlist - data -', data);
                            break;
                        case Hls.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                            logger.log('error while loading audio track - data -', data);
                            break;
                        case Hls.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                            logger.log('timeout while loading audio track - data -', data);
                            break;
                        case Hls.ErrorDetails.LEVEL_SWITCH_ERROR:
                            logger.log('error while trying to switch to level - data -', data);
                            break;
                        case Hls.ErrorDetails.FRAG_LOAD_ERROR:
                            self.hlsStatsData.segmentLoadFailed++;
                            logger.log('error while loading fragment - data -', data);
                            break;
                        case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
                            self.hlsStatsData.segmentLoadTimeout++;
                            logger.log('timeout while loading fragment - data -', data);
                            break;
                        case Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
                            self.hlsStatsData.segmentError++;
                            logger.log('Frag Loop Loading Error - data -', data);
                            break;
                        case Hls.ErrorDetails.FRAG_DECRYPT_ERROR:
                            self.hlsStatsData.segmentError++;
                            logger.log('Decrypting Error - data -', data);
                            break;
                        case Hls.ErrorDetails.FRAG_PARSING_ERROR:
                            self.hlsStatsData.segmentError++;
                            logger.log('Parsing Error - data -', data);
                            break;
                        case Hls.ErrorDetails.REMUX_ALLOC_ERROR:
                            logger.log('Error while remux alloc - data -', data);
                            break;
                        case Hls.ErrorDetails.KEY_LOAD_ERROR:
                            logger.log('error while loading key - data -', data);
                            break;
                        case Hls.ErrorDetails.KEY_LOAD_TIMEOUT:
                            logger.log('timeout while loading key - data -', data);
                            break;
                        case Hls.ErrorDetails.BUFFER_APPEND_ERROR:
                            logger.log('Buffer Append Error - data -', data);
                            break;
                        case Hls.ErrorDetails.BUFFER_ADD_CODEC_ERROR:
                            logger.log('Buffer Add Codec Error for - data -', data);
                            break;
                        case Hls.ErrorDetails.BUFFER_STALLED_ERROR:
                            logger.log('Buffer Stalled Error - data -', data);
                            if (typeof ga !== 'undefined' && ga) {
                                ga('send', 'event', options.getVideoInfo()[options.getCurrentKey()].id, 'web_buffer_stalled', 'Web Buffer Stalled', 1);
                            }
                            break;
                        case Hls.ErrorDetails.BUFFER_FULL_ERROR:
                            logger.log('Buffer Full Error - data -', data);
                            break;
                        case Hls.ErrorDetails.BUFFER_SEEK_OVER_HOLE:
                            logger.log('Error - Buffer seek over hole - data -', data);
                            if (typeof ga !== 'undefined' && ga) {
                                ga('send', 'event', options.getVideoInfo()[options.getCurrentKey()].id, 'web_buffer_seek_over_hole', 'Web Buffer Seek Over Hole', 1);
                            }
                            break;
                        case Hls.ErrorDetails.BUFFER_NUDGE_ON_STALL:
                            logger.log('Error - Buffer nudge on stall - data -', data);
                            if (typeof ga !== 'undefined' && ga) {
                                ga('send', 'event', options.getVideoInfo()[options.getCurrentKey()].id, 'web_buffer_nudge_on_stall', 'Web Buffer Nudge On Stall', 1);
                            }
                            break;
                        case Hls.ErrorDetails.BUFFER_APPENDING_ERROR:
                            logger.log('Buffer Appending Error - data -', data);
                            break;
                        default:
                            break;
                    }
                    if (data.fatal) {
                        logger.log('fatal error :' + data.details);
                        switch (data.type) {
                            case Hls.ErrorTypes.MEDIA_ERROR:
                                logger.log('Media error - data -', data);
                                hls.recoverMediaError();
                                break;
                            case Hls.ErrorTypes.NETWORK_ERROR:
                                logger.log('Network Error - data -', data);
                                break;
                            case Hls.ErrorTypes.MUX_ERROR:
                                logger.log('Muxing Error - data -', data);
                                break;
                            case Hls.ErrorTypes.OTHER_ERROR:
                                logger.log('Other Error - data -', data);
                                break;
                            default:
                                logger.log('Unrecoverable error - data -', data);
                                hls.destroy();
                                break;
                        }

                    }
                    if (!self.hlsStats) self.hlsStats = {};
                    // track all errors independently
                    if (self.hlsStats[data.details] === undefined) {
                        if (data.details === 'bufferStalledError') {
                            self.hlsStatsData.bufferStalledError = 1;
                            self.hlsStats[data.details] = self.hlsStatsData.bufferStalledError + ' (Last segment stalled:' + parseInt(self.hlsStatsData.fragLastBuffered + 1) + ')'
                        } else {
                            self.hlsStats[data.details] = 1;
                        }
                    } else {
                        if (data.details === 'bufferStalledError') {
                            self.hlsStatsData.bufferStalledError += 1
                            self.hlsStats[data.details] = self.hlsStatsData.bufferStalledError + ' (Last segment stalled:' + parseInt(self.hlsStatsData.fragLastBuffered + 1) + ')'
                        } else {
                            self.hlsStats[data.details] += 1;
                        }

                    }
                    // track fatal error
                    if (data.fatal) {
                        if (self.hlsStats.fatalError === undefined) {
                            self.hlsStats.fatalError = 1;
                        } else {
                            self.hlsStats.fatalError += 1;
                        }
                    }
                    options.updateHlsStats(self.hlsStats);
                }
            });
            hls.on(Hls.Events.FRAG_BUFFERED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('Segment was added to buffer (processed) - ' + data.frag.sn, data);

                    var latency = data.stats.tfirst - data.stats.trequest,
                        parsing = data.stats.tparsed - data.stats.tload,
                        process = data.stats.tbuffered - data.stats.trequest,
                        bitrate = Math.round(8 * data.stats.total / (data.stats.tbuffered - data.stats.tfirst));
                    if (self.hlsStatsData.fragBuffered) {
                        self.hlsStatsData.fragMinLatency = Math.min(self.hlsStatsData.fragMinLatency, latency);
                        self.hlsStatsData.fragMaxLatency = Math.max(self.hlsStatsData.fragMaxLatency, latency);
                        self.hlsStatsData.fragMinProcess = Math.min(self.hlsStatsData.fragMinProcess, process);
                        self.hlsStatsData.fragMaxProcess = Math.max(self.hlsStatsData.fragMaxProcess, process);
                        self.hlsStatsData.fragMinKbps = Math.min(self.hlsStatsData.fragMinKbps, bitrate);
                        self.hlsStatsData.fragMaxKbps = Math.max(self.hlsStatsData.fragMaxKbps, bitrate);
                        self.hlsStatsData.connectionSpeedMinKbps = Math.min(self.hlsStatsData.connectionSpeedMinKbps, bitrate);
                        self.hlsStatsData.connectionSpeedMaxKbps = Math.max(self.hlsStatsData.connectionSpeedMaxKbps, bitrate);
                        self.hlsStatsData.autoLevelCappingMin = Math.min(self.hlsStatsData.autoLevelCappingMin, hls.autoLevelCapping);
                        self.hlsStatsData.autoLevelCappingMax = Math.max(self.hlsStatsData.autoLevelCappingMax, hls.autoLevelCapping);
                        self.hlsStatsData.fragBuffered++;
                    } else {
                        self.hlsStatsData.fragMinLatency = self.hlsStatsData.fragMaxLatency = latency;
                        self.hlsStatsData.fragMinProcess = self.hlsStatsData.fragMaxProcess = process;
                        self.hlsStatsData.fragMinKbps = self.hlsStatsData.fragMaxKbps = bitrate;
                        self.hlsStatsData.connectionSpeedMinKbps = self.hlsStatsData.connectionSpeedMaxKbps = bitrate;
                        self.hlsStatsData.fragBuffered = 1;
                        self.hlsStatsData.fragBufferedBytes = 0;
                        self.hlsStatsData.autoLevelCappingMin = self.hlsStatsData.autoLevelCappingMax = hls.autoLevelCapping;
                        self.hlsStatsData.sumLatency = 0;
                        self.hlsStatsData.sumKbps = 0;
                        self.hlsStatsData.sumProcess = 0;
                        self.hlsStatsData.sumParsing = 0;
                        self.hlsStatsData.segmentSkipped = 0;
                        self.hlsStatsData.segmentError = 0;
                        self.hlsStatsData.segmentLoadFailed = 0;
                        self.hlsStatsData.segmentLoadTimeout = 0;
                    }
                    self.hlsStatsData.fragLastLatency = latency;
                    self.hlsStatsData.sumLatency += latency;
                    self.hlsStatsData.fragAvgLatency = Math.round(self.hlsStatsData.sumLatency / self.hlsStatsData.fragBuffered);
                    self.hlsStatsData.fragLastProcess = process;
                    self.hlsStatsData.sumProcess += process;
                    self.hlsStatsData.sumParsing += parsing;
                    self.hlsStatsData.fragAvgProcess = Math.round(self.hlsStatsData.sumProcess / self.hlsStatsData.fragBuffered);
                    self.hlsStatsData.fragLastKbps = bitrate;
                    self.hlsStatsData.connectionSpeedLastKbps = bitrate;
                    self.hlsStatsData.sumKbps += bitrate;
                    self.hlsStatsData.fragAvgKbps = Math.round(self.hlsStatsData.sumKbps / self.hlsStatsData.fragBuffered);
                    self.hlsStatsData.connectionSpeedAvgKbps = Math.round(self.hlsStatsData.sumKbps / self.hlsStatsData.fragBuffered);
                    self.hlsStatsData.fragBufferedBytes += data.stats.total;
                    self.hlsStatsData.fragParsingKbps = Math.round(8 * self.hlsStatsData.fragBufferedBytes / self.hlsStatsData.sumParsing);
                    self.hlsStatsData.fragParsingMs = Math.round(self.hlsStatsData.sumParsing);

                    if ((data.frag.sn !== parseInt(self.hlsStatsData.fragLastBuffered + 1)) && self.hlsStatsData.fragLastBuffered) {
                        self.hlsStatsData.segmentSkipped = self.hlsStatsData.segmentSkipped + (data.frag.sn - self.hlsStatsData.fragLastBuffered);
                    }
                    self.hlsStatsData.fragLastBuffered = data.frag.sn;
                    self.hlsStatsData.bufferedTime = data.frag.start + data.frag.duration;
                    self.segmentEnd[data.frag.sn] = self.hlsStatsData.bufferedTime;
                    //self.hlsStats.connectionSpeed = bitrate;
                    self.hlsStats.connectionSpeed = 'avg ' + self.hlsStatsData.connectionSpeedAvgKbps + ' (min. ' + self.hlsStatsData.connectionSpeedMinKbps + ', max. ' + self.hlsStatsData.connectionSpeedMaxKbps + ', last ' + self.hlsStatsData.connectionSpeedLastKbps + ')';
                    var bufferHealth = self.hlsStatsData.bufferedTime - self.getCurrentTime();
                    if (bufferHealth < 1) {
                        bufferHealth = 0;
                    }
                    self.hlsStats.bufferHealth = bufferHealth;
                    self.hlsStats.segmentLatency = 'avg ' + self.hlsStatsData.fragAvgLatency + ' (min. ' + self.hlsStatsData.fragMinLatency + ', max. ' + self.hlsStatsData.fragMaxLatency + ', last ' + self.hlsStatsData.fragLastLatency + ')';
                    //self.hlsStats.segmentBitrate = 'avg ' + self.hlsStatsData.fragAvgKbps*8 + ' (min. ' + self.hlsStatsData.fragMinKbps*8 + ' ,max. ' + self.hlsStatsData.fragMaxKbps*8 + ', last. ' + self.hlsStatsData.fragLastKbps*8 + ')';
                    self.hlsStats.segmentProcessing = 'avg ' + self.hlsStatsData.fragAvgProcess + ' (min. ' + self.hlsStatsData.fragMinProcess + ', max. ' + self.hlsStatsData.fragMaxProcess + ', last ' + self.hlsStatsData.fragLastProcess + ')';
                    self.hlsStats.segmentProblems = 'skipped ' + self.hlsStatsData.segmentSkipped + ', error ' + self.hlsStatsData.segmentError + ', load failed ' + self.hlsStatsData.segmentLoadFailed + ', load timeouts ' + self.hlsStatsData.segmentLoadTimeout + '';
                    self.hlsStats.autoLevelCappingLast = hls.autoLevelCapping;
                    self.hlsStats.autoLevelCappingMin = self.hlsStatsData.autoLevelCappingMin;
                    self.hlsStats.autoLevelCappingMax = self.hlsStatsData.autoLevelCappingMax;
                    options.updateHlsStats(self.hlsStats);
                    if (typeof ga !== 'undefined' && ga && !self.hlsGAInterval) {
                        self.hlsGAInterval = setInterval(function() {
                            ga('send', 'event', options.getVideoInfo()[options.getCurrentKey()].id, 'web_connection_speed', 'Web Connection Speed (Kbbs)', Math.ceil(self.hlsStatsData.connectionSpeedLastKbps));
                            var bufferHealth = self.hlsStatsData.bufferedTime - self.getCurrentTime();
                            if (bufferHealth < 1) {
                                bufferHealth = 0;
                            }
                            self.hlsStats.bufferHealth = bufferHealth;
                            ga('send', 'event', options.getVideoInfo()[options.getCurrentKey()].id, 'web_buffer_health', 'Web Buffer Health (s)', Math.ceil(bufferHealth));
                        }, 5000);
                    }
                }
                //options.updateVideoDuration(data.details.totalduration);
            });

            hls.on(Hls.Events.FRAG_CHANGED, function(event, data) {
                //logger.log('Fragment changed - ', data);
                if (self.tcInside !== 1) {
                    logger.log('Last Segment Received - ', self.lastSegmentReceived);

                    self.tagList = data.frag.tagList;

                    var level = data.frag.level,
                        autoLevel = data.frag.autoLevel;
                    if (self.hlsStats.levelStart === undefined) {
                        self.hlsStats.levelStart = level;
                    }
                    if (autoLevel) {
                        if (self.hlsStatsData.fragChangedAuto) {
                            self.hlsStats.autoLevelMin = Math.min(self.hlsStats.autoLevelMin, level);
                            self.hlsStats.autoLevelMax = Math.max(self.hlsStats.autoLevelMax, level);
                            self.hlsStatsData.fragChangedAuto++;
                            if (self.hlsStatsData.levelLastAuto && level !== self.hlsStats.autoLevelLast) {
                                self.hlsStats.autoLevelSwitch++;
                            }
                        } else {
                            self.hlsStats.autoLevelMin = self.hlsStats.autoLevelMax = level;
                            self.hlsStats.autoLevelSwitch = 0;
                            self.hlsStatsData.fragChangedAuto = 1;
                            self.hlsStatsData.sumAutoLevel = 0;
                        }
                        self.hlsStatsData.sumAutoLevel += level;
                        self.hlsStats.autoLevelAvg = Math.round(1000 * self.hlsStatsData.sumAutoLevel / self.hlsStatsData.fragChangedAuto) / 1000;
                        self.hlsStats.autoLevelLast = level;
                    } else {
                        if (self.hlsStats.fragChangedManual) {
                            self.hlsStats.manualLevelMin = Math.min(self.hlsStats.manualLevelMin, level);
                            self.hlsStats.manualLevelMax = Math.max(self.hlsStats.manualLevelMax, level);
                            self.hlsStats.fragChangedManual++;
                            if (!self.hlsStatsData.levelLastAuto && level !== self.hlsStats.manualLevelLast) {
                                self.hlsStats.manualLevelSwitch++;
                            }
                        } else {
                            self.hlsStats.manualLevelMin = self.hlsStats.manualLevelMax = level;
                            self.hlsStats.manualLevelSwitch = 0;
                            self.hlsStats.fragChangedManual = 1;
                        }
                        self.hlsStats.manualLevelLast = level;
                    }
                    self.hlsStatsData.levelLastAuto = autoLevel;
                    options.updateHlsStats(self.hlsStats);


                    self.hlsCurrentSegment = data.frag.relurl;
                    logger.log('%cSegment changed to - ' + self.hlsCurrentSegment, logger.specialLogStyle, data);

                }
                //options.updateVideoDuration(data.details.totalduration);
            });
            hls.on(Hls.Events.FRAG_LOAD_EMERGENCY_ABORTED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('Fragment Emergency Abort data -', data);
                    if (self.hlsStats) {
                        if (self.hlsStats.fragLoadEmergencyAborted === undefined) {
                            self.hlsStats.fragLoadEmergencyAborted = 1;
                        } else {
                            self.hlsStats.fragLoadEmergencyAborted++;
                        }
                        options.updateHlsStats(self.hlsStats);
                    }
                }
            });
            hls.on(Hls.Events.FRAG_DECRYPTED, function(event, data) {
                if (self.tcInside !== 1) {
                    logger.log('Fragment Decrypted data -', data);
                    if (!self.hlsStats.fragDecrypted) {
                        self.hlsStats.fragDecrypted = 0;
                        self.hlsStatsData.totalDecryptTime = 0;
                        self.hlsStats.fragAvgDecryptTime = 0;
                    }
                    self.hlsStats.fragDecrypted++;
                    self.hlsStatsData.totalDecryptTime += data.stats.tdecrypt - data.stats.tstart;
                    self.hlsStats.fragAvgDecryptTime = self.hlsStatsData.totalDecryptTime / self.hlsStats.fragDecrypted;
                    options.updateHlsStats(self.hlsStats);
                }
            });
        },
        changeHLS: function(src, backToOriginalHls) {
            var self = this;
            logger.log('Entered change hls');
            var hls = core.getHls();
            self.hlsDecimal = '';
            self.hlsData = '';
            if (hls && !util.isSafari()) {
                logger.log('Destroying any old livestreams');
                hls.destroy();
            }
            if (core.setHls() && !util.isSafari()) {
                var source = self.getHlsSource();
                var videoEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0]
                var hls = core.getHls();
                hls.loadSource(source);
                //hls.autoLevelCapping = -1;
                hls.attachMedia(videoEle);
                if (self.hlsInitiated !== 1 || backToOriginalHls === 1) {
                    self.hlsListners(hls, backToOriginalHls);
                    self.hlsInitiated = 1;
                }
            } else {
                core.ajax({
                    type: 'get',
                    url: self.getHlsSource(),
                    dataType: "html",
                    success: function(data) {
                        var tCReg = /(?:#TOUCHCAST-STREAM-INF:BINARY-SQUARE-SIZE=)([^&#,]*)(?:,BINARY-SQUARE-NUMBER=([^&#]*))?/;
                        var match = data.match(tCReg);
                        if (match && match[1]) {
                            options.setHlsSquareSize(match[1]);
                        }
                        if (match && match[2]) {
                            options.setHlsSquareNumber(match[2]);
                        } else {
                            options.setEncodingMechanism('new');
                        }
                        var tCReg = /(?:RESOLUTION=)([^&#,][^\n\r]*)/;
                        var match = data.match(tCReg);
                        if (match && match[1]) {
                            var dimensionGet = match[1].split('x');
                            if (dimensionGet && dimensionGet[1]) {
                                options.setHlsLevelHeight(dimensionGet[1]);
                            }
                            if (dimensionGet && dimensionGet[0]) {
                                options.setHlsLevelWidth(dimensionGet[0]);
                            }
                        }
                        self.resize();

                    }
                });
                var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                core.setAttr(vidElem, 'poster', '');
                var vidSrcNode = core.find(vidElem, 'source');
                core.setAttr(vidSrcNode, 'src', '');
                core.setAttr(vidSrcNode, 'src', self.getHlsSource());
                var elPlayer = vidElem;
                elPlayer.prop('is_playing', false);
                elPlayer[0].load();
            }
        },
        filterCallbackUrlLiveStream: function(vAppUrl, callback) {
            var regExp = /s3.amazonaws.com/;
            var match = vAppUrl.match(regExp);
            if ($.isArray(match)) {
                if (vAppUrl && vAppUrl.indexOf("?") !== -1) {
                    callback('https://cdn-assets.touchcast.com/redirection-loader-livestream/index.html?url=' + vAppUrl + '&v=' + new Date().getTime())
                } else {
                    callback('https://cdn-assets.touchcast.com/redirection-loader-livestream/index.html?url=' + vAppUrl + '?v=' + new Date().getTime())
                }
            } else {
                callback(vAppUrl);
            }
        },
        filterCallbackTypeLiveStream: function(orginalUrl, vAppUrl, type, callback) {
            var regExp = /s3.amazonaws.com/;
            var match = orginalUrl.match(regExp);
            if ($.isArray(match)) {
                callback(TouchCast.Constant.VAPP_TYPE_WEBPAGE);
            } else {
                callback(type);
            }
        },
        loadVideo: function(videoInfoData) {
            var self = this;
            logger.log('Load Video - Data -', videoInfoData);
            // check if hls
            if (videoInfoData[0]['hls'] && videoInfoData[0]['hls'] === true && this.insideChange !== 1) {
                //this.setHlsSource(videoInfoData.video_url);
                options.setHls(true);
                if (videoInfoData[0]['vod'] && videoInfoData[0]['vod'] === true) {
                    options.setHlsVod(true);
                } else {
                    TouchCast.Filter.addFilter(TouchCast.Filter.VAPP_URL, self.filterCallbackUrlLiveStream);
                    TouchCast.Filter.addFilter(TouchCast.Filter.VAPP_TYPE, self.filterCallbackTypeLiveStream);
                }
            }
            if (options.isHls()) {
                var videoInfo = [];
                if (this.insideChange === 1) {
                    options.setTotalPerf(0);
                    options.setTotalDuration(0);
                } else {
                    this.originalVideoInfo = videoInfoData;
                    this.breadCrumbVideoInfo.push(videoInfoData);
                }
                var j = 0;
                for (i in videoInfoData) {
                    options.setTotalPerf(options.getTotalPerf() + 1);
                    videoInfo[j] = videoInfoData[i];
                    j++;
                }
                options.setVideoInfo(videoInfo);
                if (this.insideChange !== 1) {
                    options.setMode('html5');
                    if (!options.getHlsVod()) {
                        interactiveLayerConfig.livestream_handler.getLivestreamData(function(e) {
                            options.setLivestreamId(e.livestream_id);
                            if (e.state === 'live' || e.state === 'paused' || e.state === 'finished') {
                                self.calledHostForPauseFinish = 0;
                                if (e.state !== 'finished' || (typeof(interactiveLayerConfig.livestream_data) !== 'undefined')) {
                                    self.setHlsSource(videoInfoData[0]['video_url']);
                                    options.setOriginalHls(videoInfoData[0]['video_url']);
                                } else if (e.state === 'finished') {
                                    if (!util.isSafari() && (typeof(interactiveLayerConfig.livestream_data) === 'undefined')) {
                                        var hls = core.getHls();
                                        hls.detachMedia();
                                    }
                                    self.hlsInitiated = 0;
                                }
                                //options.getLivestreamState() = e.state;
                                options.setLivestreamState(e.state);
                                options.setHls(true);
                                playerUI.usersViewing(e.stat.viewers);
                                if (e.state === 'live') {
                                    options.setLive(true);
                                    self.setLive();
                                }
                                if (e.data.stream_config.privacy.comments === 'on' || e.data.stream_config.privacy.comments === 'moderated') {
                                    if (self.chatInited === 0) {
                                        playerUI.initChat(options.videoInfo[0]);
                                        self.chatInited = 1;
                                    }
                                    self.setChatButtonState(1);
                                    playerUI.showChatButton();
                                } else {
                                    self.setChatButtonState(0);
                                    playerUI.hideChatButton();
                                }
                                //core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
                            } else {
                                //core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
                            }

                        });
                        if ((interactiveLayerConfig.livestream_data) && (typeof(interactiveLayerConfig.livestream_data) !== 'undefined')) {
                            self.setHlsSource(interactiveLayerConfig.livestream_data.stream_config.hls_url);
                            options.setOriginalHls(interactiveLayerConfig.livestream_data.stream_config.hls_url);
                            options.setHls(true);
                            playerUI.usersViewing(interactiveLayerConfig.livestream_data.stat.viewers);

                        }
                        // integrating new methods from daniel
                        interactiveLayerConfig.livestream_handler.setNotificationCallback(function(e) {
                            logger.log('Livestream event notification', e);
                            if (e.data && e.data.stream_config && e.data.stream_config.assets_baseurl && e.data.stream_config.assets_baseurl !== '' && e.data.stream_config.assets_baseurl !== null) {
                                options.setLivestreamAssetUrl(e.data.stream_config.assets_baseurl);
                            }
                            if (e.data && e.data.livestream && e.data.livestream.stream_config && e.data.livestream.stream_config.assets_baseurl && e.data.livestream.stream_config.assets_baseurl !== '' && e.data.livestream.stream_config.assets_baseurl !== null) {
                                options.setLivestreamAssetUrl(e.data.livestream.stream_config.assets_baseurl);
                            }
                            switch (e.type) {
                                case 'comment_new':
                                    if (self.tcInside !== 1) {
                                        playerUI.receiveChat(e.data);
                                    }
                                    break;
                                case 'users_viewing_total':
                                    if (self.tcInside !== 1) {
                                        playerUI.usersViewing(e.data);
                                    }
                                    break;
                                case 'like':
                                    if (self.tcInside !== 1) {
                                        playerUI.receiveThumbs(e.data);
                                    }
                                    break;
                                case 'configure':
                                    if (self.tcInside !== 1) {
                                        if (e.data.stream_config.privacy.comments === 'on' || e.data.stream_config.privacy.comments === 'moderated') {
                                            if (self.chatInited === 0) {
                                                playerUI.initChat(options.videoInfo[0]);
                                                self.chatInited = 1;
                                            }
                                            self.setChatButtonState(1);
                                            playerUI.showChatButton();
                                        } else {
                                            self.setChatButtonState(0);
                                            playerUI.hideChatButton();
                                        }
                                        if (e.data.stream_config.assets_baseurl && e.data.stream_config.assets_baseurl !== '' && e.data.stream_config.assets_baseurl !== null) {
                                            options.setLivestreamAssetUrl(e.data.stream_config.assets_baseurl);
                                        }
                                    }
                                    break;
                                case 'status':
                                    if (self.tcInside !== 1) {
                                        if (e.data.status === 'needs-pincode') {
                                            self.setHlsSource('');
                                            var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                                            if (options.isHlsSupported()) {
                                                var hls = core.getHls();
                                                logger.log('Destroying any old livestreams');
                                                hls.destroy();
                                                self.hlsInitiated = 0;
                                            }
                                            var vidSrcNode = core.find(vidElem, 'source');
                                            core.setAttr(vidSrcNode, 'src', '');
                                        } else if (e.data.livestream.state === 'live' || e.data.livestream.state === 'paused' || e.data.livestream.state === 'finished') {
                                            //options.getLivestreamState() = e.data.livestream.state;
                                            self.previousState = options.getLivestreamState();
                                            options.setLivestreamState(e.data.livestream.state);
                                            self.calledHostForPauseFinish = 0;
                                            logger.log('Event received for livestream - HLS Url -', e.data.livestream.stream_config.hls_url);
                                            logger.log('Event received for livestream - Original HLS Url -', self.getHlsSource());
                                            if (e.data.livestream.state === 'live' && self.getHlsSource() !== e.data.livestream.stream_config.hls_url) {
                                                self.setHlsSource(e.data.livestream.stream_config.hls_url);
                                                self.breadCrumbVideoInfo[self.breadCrumbLevel][0].video_url = e.data.livestream.stream_config.hls_url;
                                                options.setOriginalHls(e.data.livestream.stream_config.hls_url);
                                                self.hlsDecimal = '';
                                                self.hlsData = '';
                                                self.changeHLS(e.data.livestream.stream_config.hls_url);
                                                options.setHls(true);
                                                self.hlsCurrentSegment = '';
                                                self.lastSegmentReceived = '';
                                                self.hlsStatsData = {};
                                                self.hlsStats = {};
                                            }
                                            if (e.data.livestream.state === 'live') {
                                                if ((self.previousState === 'paused') && (util.isSafari())){
                                                    var elPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                                                    //elPlayer[0].load();
                                                    if(elPlayer[0].currentTime && elPlayer[0].currentTime !== 0){
                                                        logger.log('force load the hls');
                                                        //elPlayer[0].currentTime = self.getCurrentTime() + 0.01;
                                                        elPlayer[0].load();
                                                    }
                                                    //var vidSrcNode = core.find(vidElem, 'source');
                                                    //core.setAttr(vidSrcNode, 'src', self.getHlsSource());
                                                }
                                                options.setLive(true);
                                                self.setLive();
                                            }
                                            if (e.data.livestream.stream_config.privacy.comments === 'on' || e.data.livestream.stream_config.privacy.comments === 'moderated') {
                                                if (self.chatInited === 0) {
                                                    playerUI.initChat(options.videoInfo[0]);
                                                    self.chatInited = 1;
                                                }
                                                self.setChatButtonState(1);
                                                playerUI.showChatButton();
                                            } else {
                                                self.setChatButtonState(0);
                                                playerUI.hideChatButton();
                                            }
                                            if (e.data.livestream.state === 'paused') {
                                                if (e.data.last_segment_name) {
                                                    if (self.previousState !== e.data.livestream.state) {
                                                        self.lastSegmentReceived = e.data.last_segment_name;
                                                    }
                                                    if (self.lastSegmentReceived === self.hlsCurrentSegment) {
                                                        self.calledHostForPauseFinish = 1;
                                                        self.liveStateCalled = 0;
                                                        logger.log('Showing paused state');
                                                        interactiveLayerConfig.livestream_handler.reachedState('paused');
                                                    }
                                                } else {
                                                    if (self.previousState !== e.data.livestream.state) {
                                                        self.calledHostForPauseFinish = 1;
                                                        self.liveStateCalled = 0;
                                                        logger.log('Showing paused state');
                                                        interactiveLayerConfig.livestream_handler.reachedState('paused');
                                                    }
                                                }
                                            }
                                            if (e.data.livestream.state === 'finished' && (typeof(interactiveLayerConfig.livestream_data) === 'undefined')) {
                                                logger.log('Last segment received from pusher - ', e.data.last_segment_name);
                                                if (e.data.last_segment_name) {
                                                    if (self.previousState !== e.data.livestream.state) {
                                                        self.lastSegmentReceived = e.data.last_segment_name;
                                                    }
                                                } else {
                                                    if (self.previousState !== e.data.livestream.state) {
                                                        logger.log('Showing finished state');
                                                        self.calledHostForPauseFinish = 1;
                                                        self.hlsDecimal = '';
                                                        self.hlsData = '';
                                                        //TouchCast.InteractiveLayer.exitPipMode();
                                                        interactiveLayerConfig.livestream_handler.reachedState('finished');
                                                    }
                                                }
                                                self.hlsInitiated = 0;
                                            }
                                            options.setLivestreamId(e.data.livestream.livestream_id);
                                            //core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
                                            playerUI.usersViewing(e.data.livestream.stat.viewers);
                                        } else {
                                            //core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
                                            playerUI.usersViewing(e.data.livestream.stat.viewers);
                                        }

                                    }
                                    break;
                            }
                        });
                    } else {
                        self.setHlsSource(videoInfoData[0]['video_url']);
                        options.setOriginalHls(videoInfoData[0]['video_url']);
                    }
                    logger.log('Load HlS');
                    var hlsCheck = core.getHls();
                    if (!hls) {
                        hlsCheck = core.setHls();
                    }
                    if (hlsCheck && !util.isSafari()) {
                        options.setHlsSupport(true);
                        playerUI.buildUI(this.getHlsSource());
                        options.setTotalDuration(0);
                        var source = this.getHlsSource();
                        logger.log('Initial HLS Source -', source);
                        if (source !== '') {
                            if (options.getLivestreamState() !== 'finished' || (typeof(interactiveLayerConfig.livestream_data) !== 'undefined')) {
                                var videoEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0]
                                var hls = core.getHls();
                                hls.loadSource(source);
                                //hls.autoLevelCapping = -1;
                                hls.attachMedia(videoEle);
                            }
                            self.hlsListners(hls);
                            self.hlsInitiated = 1;
                        }
                    } else {
                        options.setHlsSupport(false);
                        logger.log('Livestream Load in Safari');
                        if (this.getHlsSource() !== '') {
                            core.ajax({
                                type: 'get',
                                url: this.getHlsSource(),
                                dataType: "html",
                                success: function(data) {
                                    var tCReg = /(?:#TOUCHCAST-STREAM-INF:BINARY-SQUARE-SIZE=)([^&#,]*)(?:,BINARY-SQUARE-NUMBER=([^&#]*))?/;
                                    var match = data.match(tCReg);
                                    if (match && match[1]) {
                                        options.setHlsSquareSize(match[1]);
                                    }
                                    if (match && match[2]) {
                                        options.setHlsSquareNumber(match[2]);
                                    } else {
                                        options.setEncodingMechanism('new');
                                    }
                                    var tCReg = /(?:RESOLUTION=)([^&#,][^\n\r]*)/;
                                    var match = data.match(tCReg);
                                    if (match && match[1]) {
                                        var dimensionGet = match[1].split('x');
                                        if (dimensionGet && dimensionGet[1]) {
                                            options.setHlsLevelHeight(dimensionGet[1]);
                                        }
                                        if (dimensionGet && dimensionGet[0]) {
                                            options.setHlsLevelWidth(dimensionGet[0]);
                                        }
                                    }
                                    self.resize();

                                }
                            });
                        }

                        playerUI.buildUI(self.getHlsSource());
                    }

                }
                //playerUI.updateInfoPanel(videoInfo[0], this.isAjaxAllowed());

                /*if (videoInfo[0].tc_type == 'note')
                    options.setTcVideoType(videoInfo[0].tc_type);*/
                if (this.insideChange === 1)
                    playerUI.updateSharePanel();
                self.resize();
                core.on(core.init(window), 'orientationchange resize', function() {
                    self.resize();
                });
                playerUI.hideRecastButton();
                playerUI.initHoverActive();
                playerUI.hideCommentButton();
                this.setSearchButtonState(1);
                this.setThumbsButtonState(1);
                this.setLiveButtonState(1);
                this.setShareButtonState(0);
                this.setInfoButtonState(0);
                playerUI.hideShareButton();
                playerUI.hideInfoButton();
                if (((interactiveLayerConfig.livestream_data) && (typeof(interactiveLayerConfig.livestream_data) !== 'undefined')) || (options.getHlsVod())) {
                    this.setChatButtonState(0);
                    this.setSearchButtonState(0);
                    this.setThumbsButtonState(0);
                    this.setLiveButtonState(0);
                }
            } else {
                var self = this;
                this.setChatButtonState(0);
                this.setSearchButtonState(0);
                this.setThumbsButtonState(0);
                this.setLiveButtonState(0);
                playerUI.hideChatButton();
                playerUI.hideThumbsButton();
                playerUI.hideLiveButton();
                var videoInfo = [];
                if (this.insideChange === 1) {
                    options.setTotalPerf(0);
                    options.setTotalDuration(0);
                    if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '' && typeof options.videoInfo !== 'undefined' && options.videoInfo !== '') {
                        try {
                            if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                                var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                            } else {
                                var originalInfo = '';
                            }
                            TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_ENDED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                        } catch (err) {
                            console.error(err);
                        }
                    }
                } else {
                    this.originalVideoInfo = videoInfoData;
                    this.breadCrumbVideoInfo.push(videoInfoData);
                }
                j = 0;
                for (i in videoInfoData) {
                    options.setTotalPerf(options.getTotalPerf() + 1);
                    if (videoInfoData[i]['duration'] !== '') {
                        options.setTotalDuration(options.getTotalDuration() + parseFloat(videoInfoData[i]['duration']));
                    }
                    videoInfo[j] = videoInfoData[i];
                    j++;
                }
                options.setDomain(util.getDomain(videoInfo[options.getCurrentKey()].url));

                if (videoInfo[0].tc_type === 'note' || videoInfo[0].tc_type === 'livestream')
                    options.setTcVideoType(videoInfo[0].tc_type);

                if (this.insideChange !== 1) {
                    var hasWebmVideo = (videoInfo[0].videoWebm) ? true : '';
                    if (TouchCast.InteractiveLayer.getPlayerMode(hasWebmVideo) === 'html5') {
                        options.setMode('html5');
                        playerUI.buildUI(videoInfo[0]);
                    } else {
                        playerUI.buildFlashUI(videoInfo[0]);
                        if (!FlashDetect.installed) {
                            core.addClass(core.init('.' + constants.CSS_TOUCHCAST_MAIN_WRAPPER + ''), constants.CSS_TOUCHCAST_NO_FLASH);
                            return;
                        } else {
                            logger.log('Timer Start for checking flash ready if html5 is not supported');
                            options.flashInterval = window.setInterval(function() {
                                self.flashReady(videoInfo[0]);
                            }, 500);
                        }
                        options.setMode('flash');
                    }
                }
                playerUI.updateInfoPanel(videoInfo[0], this.isAjaxAllowed(), this);
                options.setVideoInfo(videoInfo);

                if (this.insideChange === 1)
                    playerUI.updateSharePanel();
                self.resize();
                core.on(core.init(window), 'orientationchange resize', function() {
                    self.resize();
                });
                if (options.getUser() !== null && options.getUser().getUserId() !== '' && videoInfo[0].user.user_id === options.getUser().getUserId()) {
                    playerUI.hideRecastButton();
                } else if (self.getRecastButtonState() !== 0) {
                    playerUI.showRecastButton();
                }
                playerUI.initHoverActive();
            }
        },
        changeTouchCast: function(starttime, navigate, TCID, directLoad, tcInsideTc) {
            if (this.changingTC === 0) {
                if (tcInsideTc === 1 && this.firstTCLevel === -1) {
                    this.firstTCLevel = this.breadCrumbLevel;
                }
                this.breadCrumbLevel++;
                var jumpTime = 0;
                if (typeof starttime !== 'undefined' && starttime !== '')
                    jumpTime = starttime;
                options.setJumpTime(jumpTime);
                options.setOriginalTime(this.breadCrumbLevel, this.getCurrentTime());
                //this.hlsCurrentTime = (this.breadCrumbLevel, this.getCurrentTime());
                this.changingTC = 1;
                options.setTotalPerf(0);
                options.setClickPlay(0);
                chapter.setChapterClick(1);
                chapter.setChapterTime(0);
                if (directLoad === 1) {
                    this.directLoad = 1;
                    if (util.isAndroid()) {
                        var elPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                        self.playPromise(elPlayer)
                        elPlayer[0].pause();
                    }
                }
                if (typeof TCID !== 'undefined' && TCID !== '')
                    this.insideChange = 1;
                else
                    this.insideChange = 0;
                var showBackToOriginal = 1;
                if (typeof navigate !== 'undefined' && navigate !== '')
                    showBackToOriginal = 0;
                options.setShowBackToOriginal(showBackToOriginal);
                core.empty(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_LIST_ITEM + ''));
            }
        },
        changeVideo: function(videoInfoData) {
            this.insideChange = 1;
            for (var i in videoInfoData) {
                this.replaceVideo(videoInfoData[i].video_url, videoInfoData);
            }
            this.changingTC = 0;
            playerUI.initHoverActive();
            var transcriptEle = core.init('.' + constants.CSS_TOUCHCAST_TRANSCRIPT + '');
            core.empty(transcriptEle);
        },
        replaceVideo: function(vidUrl, videoInfoData) {
            var self = this;
            self.tcInside = 1;
            if (options.getMode() === 'html5') {
                var support = !(util.isChrome() || util.isFirefoxa());
                if (!options.isHlsSupported() && videoInfoData[0].hls && !support) {
                  TouchCast.InteractiveLayer.notifyVideoIsLoaded(this.breadCrumbVideoInfo[0][0].id);
                  this.breadCrumbLevel--;
                  self.resumeVideo();
                  playerUI.showNotificationError('Oops! Something went wrong and we can\'t load this TC inside TC vApp. Try again later.');
                  return;
                }
                var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                core.setAttr(vidElem, 'poster', '');
                if (options.isHls()) {
                    self.originalChatButtonState = self.getChatButtonState();
                    self.setChatButtonState(0);
                    self.setSearchButtonState(0);
                    self.setThumbsButtonState(0);
                    self.setLiveButtonState(0);
                    playerUI.hideChatButton();
                    playerUI.hideThumbsButton();
                    playerUI.hideLiveButton();
                    self.disableLive();
                    options.setLive(false);
                    TouchCast.InteractiveLayer.setHLS(false);
                    self.hlsData='';
                    self.hlsBaseUrlActions='';
                    self.hlsUUID='';
                    self.hlsDecimal='';
                    if (self.initialInfoBtn !== 0) {
                        if (self.btnsInitiated === 0) {
                            playerUI.initInfoPanel(options.videoInfo[0], this.isAjaxAllowed());
                        }
                        playerUI.showInfoButton();
                        if (self.getInfoBoxCountersState() === 0)
                            playerUI.hideInfoBoxCounters();
                        if (self.getInfoBoxBookmarkButtonState() === 0)
                            playerUI.hideInfoBoxBookmarkButton();
                        if (self.getInfoBoxFollowButtonState() === 0)
                            playerUI.hideInfoBoxFollowButton();
                        if (self.getInfoBoxFlagButtonState() === 0)
                            playerUI.hideInfoBoxFlagButton();
                    }

                    if (self.initialShareBtn !== 0) {
                        if (self.btnsInitiated === 0) {
                            playerUI.initShare();
                        }
                        playerUI.showShareButton();
                    }

                    if (self.initialRecastBtn !== 0) {
                        if (self.btnsInitiated === 0) {
                            playerUI.initReCast(self.isAjaxAllowed());
                        }
                        playerUI.showRecastButton();
                    }

                    if (self.initialCommentBtn !== 0) {
                        if (self.btnsInitiated === 0) {
                            playerUI.initComment(options.videoInfo[0], this.isAjaxAllowed());
                        }
                        playerUI.showCommentButton();
                    }
                    self.btnsInitiated = 1;
                    if (options.isHlsSupported()) {
                        var mp4VideoSrcNode = core.init('<source type="video/mp4">');
                        core.append(vidElem, mp4VideoSrcNode);
                        var hls = core.getHls();
                        hls.detachMedia();
                        core.removeAttr(vidElem, 'src')
                    }
                    options.setHls(false);
                }
                var vidSrcNode = core.find(vidElem, 'source');
                core.setAttr(vidSrcNode, 'src', '');
                core.setAttr(vidSrcNode, 'src', vidUrl);
                core.remove(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_LIST_ITEM + ''));
                if (options.getShowBackToOriginal() === 1)
                    playerUI.showTCInsideTCHeader(this);
                if (typeof videoInfoData !== 'undefined' && videoInfoData !== '') {
                    this.loadVideo(videoInfoData);
                    this.breadCrumbVideoInfo.push(videoInfoData);
                } else if (videoInfoData.tc_type === 'note' || videoInfoData.tc_type === 'livestream') {
                    options.setTcVideoType(videoInfoData.tc_type);
                }
                var elPlayer = vidElem;
                elPlayer.prop('is_playing', false);
                elPlayer[0].load();
                playerUI.initStats(this, self.config);
                //elPlayer[0].play();
                if (!options.isiPhonePlay()) {
                    if (util.isiPad()) {
                        if (this.directLoad !== 1) {
                            self.playPromise(elPlayer)
                        } else {
                            options.setClickPlay(1);
                            this.directLoad = 0;
                        }
                    } else {
                        self.playPromise(elPlayer)
                    }
                } else {
                    this.pauseVideo(1);
                    this.setCurrentTime(0);
                    var audio = options.getAudio();
                    audio.crossOrigin = "anonymous";
                    audio.load();
                    audio.src = vidUrl;
                    if (this.directLoad !== 1) {
                        this.resumeVideo();
                    } else {
                        options.setClickPlay(1);
                        options.getAudio().currentTime = 0;
                        options.setPrevTime(Date.now());
                        options.setPlaying(true);
                        playerUI.videoTick();
                        options.setPlaying(true);
                        this.directLoad = 0;
                    }
                }
                if (options.getJumpTime() !== 0)
                    chapter.setChapterTime(options.getJumpTime());
                else
                    chapter.setChapterTime(0);

                options.setEnded(0);
                if (!options.isiPhonePlay()) {
                    options.setPaused(0);
                }
            } else {
                var flashMovie = options.getFlashMovie();
                flashMovie["TouchCast.FlashSDK.Fallback.playVideo"](vidUrl);
                playerUI.updatePlayPauseButton(core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ''), 'play');
                options.setEnded(0);
                options.setPaused(0);
                core.remove(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_LIST_ITEM + ''));
                if (options.getShowBackToOriginal() === 1)
                    playerUI.showTCInsideTCHeader(this);
                if (typeof videoInfoData !== 'undefined' && videoInfoData !== '') {
                    this.loadVideo(videoInfoData);
                    this.breadCrumbVideoInfo.push(videoInfoData);
                }
                var x = 0;
                if (options.getJumpTime() !== 0)
                    x = options.getJumpTime() / videoInfoData['duration'];
                flashMovie["TouchCast.FlashSDK.Fallback.seekVideo"](x);
            }
            if (this.getCommentButtonState() !== 0) {
                options.setFirstTimeLoad(0);
                playerUI.clearControlSelections();
                playerUI.initComment(options.videoInfo[0], this.isAjaxAllowed());
            }
            if (options.getUser() !== null && options.getUser().getUserId() !== '' && videoInfoData[0].user.user_id === options.getUser().getUserId()) {
                playerUI.hideRecastButton();
            } else if (this.getRecastButtonState() !== 0) {
                playerUI.showRecastButton();
            }
        },
        goBackToOriginal: function() {
            var self = this;

            this.breadCrumbLevel--;
            var backVideoInfo = this.breadCrumbVideoInfo[this.breadCrumbLevel];
            for (i in backVideoInfo) {
                var originalVideoId = backVideoInfo[i].id;
                if (this.changeOriginal === 0) {
                    this.backToOriginal = 1;
                    this.changeOriginal = 1;
                    options.setTotalPerf(0);
                    options.setTotalDuration(0);
                    chapter.setChapterClick(0);
                    options.setClickPlay(0);
                    options.setChanging(1);
                    this.insideChange = 1;
                    options.videoInfo = '';
                    var vidUrl = backVideoInfo[i].video_url;
                    core.remove(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_LIST_ITEM + ''));
                    if (this.breadCrumbLevel === this.firstTCLevel) {
                        core.remove(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_HEADER + ''));
                        this.firstTCLevel = -1;
                    }
                    if (options.getMode() === 'html5') {
                        logger.log('Video URL - ', vidUrl);
                        if (self.getHlsSource() === vidUrl) {
                            self.tcInside = 0;
                            var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                            if (options.isHlsSupported()) {
                                var vidSrcNode = core.find(vidElem, 'source');
                                core.remove(vidSrcNode);
                            }
                            playerUI.hideRecastButton();
                            playerUI.hideCommentButton();
                            playerUI.hideShareButton();
                            playerUI.hideInfoButton();
                            self.setSearchButtonState(1);
                            self.setThumbsButtonState(1);
                            self.setLiveButtonState(1);
                            self.setShareButtonState(0);
                            self.setInfoButtonState(0);
                            self.hlsData='';
                            self.hlsBaseUrlActions='';
                            self.hlsUUID='';
                            self.hlsDecimal='';
                            if (self.originalChatButtonState === 1) {
                                playerUI.showChatButton();
                                self.setChatButtonState(1);
                            }
                            playerUI.showThumbsButton();
                            playerUI.showLiveButton();
                            self.changeHLS(self.getHlsSource(), 1);
                            options.setHls(true);
                            options.setLive(true);
                            TouchCast.InteractiveLayer.setHLS(true);
                            self.loadVideo(backVideoInfo);
                            var elPlayer = vidElem;
                            self.playPromise(elPlayer)
                            self.setLive();
                            self.hlsDecimal = '';
                            self.hlsData = '';

                            var chapterTime = 0;
                            if (options.getJumpTime())
                                chapterTime = options.getJumpTime();
                            else if (options.getOriginalTime(this.breadCrumbLevel))
                                chapterTime = options.getOriginalTime(this.breadCrumbLevel);

                            controls = self.controls;
                            //controls.currentTime.text(util.formatTime(self.hlsCurrentTime, controls.hasHours));
                        } else {
                            var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                            var vidSrcNode = core.find(vidElem, 'source');
                            core.setAttr(vidSrcNode, 'src', '');
                            core.setAttr(vidSrcNode, 'src', vidUrl);
                            this.loadVideo(backVideoInfo);
                            var elPlayer = vidElem;
                            elPlayer.prop('is_playing', false);
                            elPlayer[0].pause();
                            elPlayer[0].load();
                            if (!options.isiPhonePlay()) {
                                self.playPromise(elPlayer)
                            } else {
                                this.pauseVideo(1);
                                var audio = options.getAudio();
                                audio.crossOrigin = "anonymous";
                                audio.src = vidUrl;
                            }

                            options.setPaused(0);
                            self.disableLive();
                            options.setLive(false);
                            options.setHls(false);
                            TouchCast.InteractiveLayer.setHLS(false);
                            var chapterTime = 0;
                            if (options.getJumpTime())
                                chapterTime = options.getJumpTime();
                            else if (options.getOriginalTime(this.breadCrumbLevel))
                                chapterTime = options.getOriginalTime(this.breadCrumbLevel);
                            chapter.setChapterTime(chapterTime);

                            var self = this;
                            if (options.isiPhonePlay()) {
                                options.getAudio().addEventListener('canplay', function() {
                                    options.getAudio().currentTime = chapterTime;
                                    elPlayer[0].currentTime = chapterTime;
                                    playerUI.drawVideoFrame();
                                    //this.pauseVideo(1);
                                    self.resumeVideo();
                                    options.getAudio().removeEventListener('canplay', function() {});
                                    //core.show(core.init('.' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ''));
                                });

                            }
                        }
                    } else {
                        var flashMovie = options.getFlashMovie();
                        flashMovie["TouchCast.FlashSDK.Fallback.playVideo"](vidUrl);
                        playerUI.updatePlayPauseButton(core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ''), 'play');
                        options.setEnded(0);
                        options.setPaused(0);
                        var originalVideoDuration = backVideoInfo[i]['duration'];
                        this.loadVideo(backVideoInfo);
                        var x = 0;
                        if (options.getJumpTime() !== 0)
                            x = options.getJumpTime() / originalVideoDuration;
                        else if (options.getOriginalTime(this.breadCrumbLevel))
                            x = options.getOriginalTime(this.breadCrumbLevel) / originalVideoDuration;
                        flashMovie["TouchCast.FlashSDK.Fallback.seekVideo"](x);
                    }
                    playerUI.addKeyPoints(this.originalVappsInfo[this.breadCrumbLevel]);
                    var transcriptEle = core.init('.' + constants.CSS_TOUCHCAST_TRANSCRIPT + '');
                    core.empty(transcriptEle);
                    var cntr = 0;
                    for (i in this.originalVappsInfo[this.breadCrumbLevel][0].subtitles) {
                        cntr++;
                    }
                    if (!core.isEmptyObject(this.originalVappsInfo[this.breadCrumbLevel][0].subtitles)) {
                        this.setTranscriptionsButtonState(1);
                        playerUI.showTranscriptButton();
                        if (cntr > 1) {
                            playerUI.showSettingsButton();
                        }
                        playerUI.setPlayerLanguageForSettingsIcon();
                        playerUI.setPlayerLanguageForSettingsPanel();
                        playerUI.setPlayerLanguageForSubtitlesIcon();
                    } else {
                        playerUI.hideTranscriptButton();
                        playerUI.hideSettingsButton();
                        this.setTranscriptionsButtonState(0);
                    }
                    this.changeOriginal = 0;
                }
                TouchCast.InteractiveLayer.notifyVideoIsLoaded(originalVideoId);
            }
            if (this.getCommentButtonState() !== 0) {
                options.setFirstTimeLoad(0);
                playerUI.clearControlSelections();
                playerUI.initComment(options.videoInfo[0], this.isAjaxAllowed());
            }
            playerUI.initHoverActive();
            this.breadCrumbVideoInfo.pop();
        },
        getVideoInfo: function() {
            return options.getVideoInfo();
        },
        build: function(videoInfoData) {
            logger.log('Everything is ready for the player');
            if (videoInfoData[0].hls && !options.isHlsSupported() && this.insideChange === 1) {
                logger.log('returning as hls native is not supported natively');
                this.tcInside = 0;
                playerUI.addKeyPoints(options.getVideoInfo());
                return;
            }
            // show comments if exported livestream
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                playerUI.showCommentButton();
                this.setCommentButtonState(1);
                this.initialCommentBtn = 0;
            }

            var videoInfo = [];

            j = 0;
            for (i in videoInfoData) {
                videoInfo[j] = videoInfoData[i];
                j++;
            }
            options.setVideoInfo(videoInfo);
            if (!this.originalVappsInfo)
                this.originalVappsInfo = {};
            this.originalVappsInfo[this.breadCrumbLevel] = videoInfo;
            //core.empty(core.init('.' + constants.CSS_TOUCHCAST_VAPP_CONTAINER + ''));
            if (!options.isHls()) {
                if (options.getTotalDuration() !== 0) {
                    playerUI.addKeyPoints(options.getVideoInfo());
                }
            }
            var cntr = 0;
            for (i in options.getVideoInfo()[0].subtitles) {
                cntr++;
            }
            if (!core.isEmptyObject(options.getVideoInfo()[0].subtitles)) {
                this.setTranscriptionsButtonState(1);
                playerUI.initTranscriptions(options.getVideoInfo()[0].subtitles, this);
                playerUI.showTranscriptButton();
                if (cntr > 1) {
                    playerUI.showSettingsButton();
                }
                playerUI.setPlayerLanguageForSettingsIcon();
                playerUI.setPlayerLanguageForSettingsPanel();
                playerUI.setPlayerLanguageForSubtitlesIcon();
                playerUI.initSettings(this);
            } else {
                playerUI.hideTranscriptButton();
                playerUI.hideSettingsButton();
                this.setTranscriptionsButtonState(0);
            }
            if (this.insideChange === 1) return;
            this.buildPlayer();

            if (typeof document.hidden !== 'undefined') {
                options.hidden = 'hidden';
                options.visibilityChange = 'visibilitychange';
            } else if (typeof document.mozHidden !== 'undefined') {
                options.hidden = 'mozHidden';
                options.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                options.hidden = 'msHidden';
                options.visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                options.hidden = 'webkitHidden';
                options.visibilityChange = 'webkitvisibilitychange';
            }
            if (options.isiPhonePlay()) {
                this.iosAudio();
            }
            var hasWebmVideo = (options.videoInfo[0].videoWebm) ? true : '';
            if (TouchCast.InteractiveLayer.getPlayerMode(hasWebmVideo) === 'html5')
                this.handleInteraction();

            playerUI.initHoverActive();
            if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                try {
                    if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                        var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                    } else {
                        var originalInfo = '';
                    }
                    TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.EMBED_PLAYER_FULLY_READY, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                } catch (err) {
                    console.error(err);
                }
            }
        },
        buildPlayer: function() {
            var self = this;
            logger.log('Start Building the player');
            var videoEle = (options.getMode() === 'html5') ? core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '') : core.init(options.getFlashMovie());
            var controls = {
                video: videoEle,
                playpause: core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ''),
                total: core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_TRACK + ''),
                duration: core.init('.' + constants.CSS_TOUCHCAST_DURATION_LABEL + ''),
                currentTime: core.init('.' + constants.CSS_TOUCHCAST_CURRENT_TIME_LABEL + ''),
                progress: core.init('.' + constants.CSS_TOUCHCAST_PROGRESS + ''),
                buffered: core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_BUFFER + ''),
                hasHours: false,
                isDragging: false,
                togglePlayback: function() {
                    if (options.getPaused() === 1) {
                        logger.log('Clicked Play');
                        if (options.isEnded())
                            self.setCurrentTime(0);
                        options.setEnded(0);
                        self.resumeVideo();
                        if (util.isiPad) {
                            core.hide(core.init('.' + constants.CSS_TOUCHCAST_POSTER + ''))
                        }
                        options.setClickPlay(0);
                        options.setUserActive(0);
                        if (self.hasEndScreen() !== 0) {
                            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_END_OVERLAY + '').fadeOut();
                        }
                    } else {
                        logger.log('Clicked Pause');
                        self.pauseVideo(1);
                        options.setUserActive(0);
                    }
                    if (util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid()) {
                        core.addClass(this.playpause, constants.CSS_TOUCHCAST_ACTIVE);
                        setTimeout(function() {
                            core.removeClass(controls.playpause, constants.CSS_TOUCHCAST_ACTIVE);
                        }, 700);
                    }
                }
            };
            options.setVideo(controls.video);
            this.controls = controls;

            chapter.setChapterClick(0);
            chapter.setChapterTime(0);
            if (util.isAndroid()) {
                var eventName = 'mousedown';
            } else {
                var eventName = 'touchstart click';
            }
            core.off(controls.playpause, eventName);
            core.on(controls.playpause, eventName, function(e) {
                if (util.isiPad()) {
                    var vid = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                    if (vid[0].paused) {
                        self.resumeVideo();
                        return false;
                    } else { 
                        options.setPaused(0);
                    }
                }
                e.preventDefault();
                e.stopImmediatePropagation();
                controls.togglePlayback();
                return false;
            });
            if (options.getMode() === 'html5') {
                var elPlayer = controls.video;
                core.setAttr(elPlayer, 'is_playing', false);
                elPlayer[0].load();
                this.initialLoad = true;
                if (util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid() || util.getFFVersion() >= 35 || (util.getFFVersion() >= 28 && options.videoInfo[0].videoWebm !== 'undefined')) {
                    if (!options.isiPhonePlay() && !util.checkIfInlinePlaySupported()) {
                        self.resumeVideo();
                    }
                    if (util.getFFVersion() >= 35 || (util.getFFVersion() >= 28 && options.videoInfo[0].videoWebm !== 'undefined')) {
                        core.fadeOut(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''), 'fast');
                        core.show(core.init('.' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ''));
                    }

                    if (util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid())
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ''));

                    if ((util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid()) && (options.isHls() && !options.getHlsVod() && (typeof(interactiveLayerConfig.livestream_data) === 'undefined'))) {
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ''));
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_TIMECODE + ''));
                        //core.show(core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_LIVE_SETTINGS+ ''));
                    }

                    self.doClickPlay();
                    //self.pauseVideo(1);
                }

                elPlayer[0].addEventListener('play', function() {
                    self.onPlay();
                    if (util.isiPad()) {
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_POSTER + ''))
                    }
                });


                elPlayer[0].addEventListener('pause', function() {
                    self.onPause();
                });

                elPlayer[0].addEventListener('canplay', function() {
                    if (options.getTotalDuration() === 0) {
                        var elPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                        options.setTotalDuration(options.getTotalDuration() + parseFloat(elPlayer[0].duration));
                        if (!options.isHls()) {
                            playerUI.addKeyPoints(options.getVideoInfo());
                        }
                    }
                    options.setVideoDuration(this['duration']);
                    if (self.backToOriginal === 1 && options.getOriginalTime(self.breadCrumbLevel) !== 0) {
                        self.setCurrentTime(options.getOriginalTime(self.breadCrumbLevel));
                        //options.setOriginalTime(0);
                        self.backToOriginal = 0;
                    }
                    if (self.insideChange !== 1)
                        self.onCanPlay();
                    else
                        self.updateDuration(self.controls);
                });

                if (self.getProgressBarState() !== 0) {
                    elPlayer[0].addEventListener('seeking', function() {
                        self.onSeek();
                    });
                    elPlayer[0].addEventListener('seeked', function() {
                        self.onSeeked();
                    });
                }

                elPlayer[0].addEventListener('ended', function() {
                    if (!options.isLive()) {
                        events.triggerEvent(constants.EVENT_VIDEO_END);
                        if (self.hasEndScreen() !== 0) {
                            playerUI.showEndScreen();
                            this.currentTime = 0;
                        }
                        if (typeof receiver !== 'undefined' && receiver !== '') {
                            try {
                                receiver.emit('ended');
                            } catch (err) {
                                console.error(err);
                            }
                        }
                        if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                            try {
                                if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                                    var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                                } else {
                                    var originalInfo = '';
                                }
                                TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_ENDED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                            } catch (err) {
                                console.error(err);
                            }
                        }
                        if (self.getLoop() === 0)
                            self.pauseVideo(1);
                        else
                            self.resumeVideo();
                    } else {
                        if (!options.getHlsVod() && (typeof(interactiveLayerConfig.livestream_data) === 'undefined')) {
                            logger.log('Showing finished state');
                            interactiveLayerConfig.livestream_handler.reachedState('finished');
                        }
                    }
                });

                // reset timer for browser minimized for long time when timer is stopped by browser
                core.init(window).focus(function() {
                    var currentDateTime = Date.now();
                    if ((options.progressInterval !== '') && ((currentDateTime - self.timeUpdateStartTime) > 500)) {
                        var intervalTime = 50;
                        clearInterval(options.progressInterval);
                        options.progressInterval = setInterval(function() {
                            self.timeUpdateStartTime = Date.now();
                            if (options.getPaused() !== 1 && options.isChanging() !== 1) {
                                self.onTimeUpdate(options.getVideoDuration());
                            }
                        }, intervalTime);
                    }

                });

            } else if (options.getMode() === 'flash') {
                self.doClickPlay();
            }

            if (self.getVolumeButtonState() !== 0) {
                self.initVolumeControl();
            }

            if (self.getFullScreenButtonState() !== 0) {
                self.initFullScreen();
            }

            if (self.getInfoButtonState() !== 0) {
                playerUI.initInfoPanel(options.videoInfo[0], this.isAjaxAllowed());
                if (self.getInfoBoxCountersState() === 0)
                    playerUI.hideInfoBoxCounters();
                if (self.getInfoBoxBookmarkButtonState() === 0)
                    playerUI.hideInfoBoxBookmarkButton();
                if (self.getInfoBoxFollowButtonState() === 0)
                    playerUI.hideInfoBoxFollowButton();
                if (self.getInfoBoxFlagButtonState() === 0)
                    playerUI.hideInfoBoxFlagButton();
            }

            if (self.getShareButtonState() !== 0) {
                playerUI.initShare();
            }

            if (self.getRecastButtonState() !== 0) {
                playerUI.initReCast(this.isAjaxAllowed());
            }

            if (self.getCommentButtonState() !== 0) {
                playerUI.initComment(options.videoInfo[0], this.isAjaxAllowed());
            }
            if (self.getChatButtonState() !== 0) {
                playerUI.initChat(options.videoInfo[0]);
                self.chatInited = 1;
            } else {
                playerUI.hideChatButton();
            }
            if (self.getSearchButtonState() !== 0) {
                playerUI.initSearch(options.videoInfo[0]);
            }
            if (self.getThumbsButtonState() !== 0) {
                playerUI.initThumbs(options.videoInfo[0]);
            } else {
                playerUI.hideThumbsButton();
            }
            if (self.getLiveButtonState() !== 0) {
                playerUI.initPresence(options.videoInfo[0]);
            } else {
                playerUI.hideLiveButton();
            }
            /*if (self.getSettingsButtonState() != 0) {
                playerUI.initSettings(self);
            }*/

            if (this.hasEndScreen() !== 0) {
                playerUI.initEndScreen(self.getShareButtonState(), self);
            }
        },
        flashReady: function(videoInfo) {
            logger.log('Check if flash ready if html5 is not supported');
            var flashMovie = options.getFlashMovie();
            if (!flashMovie) {
                flashMovie = util.getFlashMovieObject(constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT);
                options.setFlashMovie(constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT);
            }
            if (flashMovie) {
                if (typeof(flashMovie["TouchCast.FlashSDK.Fallback.getTotalTime"]) === 'function') {
                    if (flashMovie["TouchCast.FlashSDK.Fallback.getTotalTime"]() > 0) {
                        window.clearInterval(options.flashInterval);
                        options.setVideoDuration(flashMovie["TouchCast.FlashSDK.Fallback.getTotalTime"]());
                        this.buildFlashPlayer(videoInfo);
                    } else {
                        playerUI.showLoading();
                    }
                }
            }
        },
        buildFlashPlayer: function(videoInfo) {
            logger.log('Ready to play in flash if html5 not supported');
            TouchCast.InteractiveLayer.setFlashMovie(constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT);
            core.fadeOut(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''), 'fast');
            core.show(core.init('.' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ''));
            this.controls.video = core.init(options.getFlashMovie());
            this.handleInteraction();

            this.onCanPlay();
            this.resize();
        },
        handleInteraction: function() {
            var self = this;
            var videoEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
            if (options.isiPhonePlay())
                videoEle = core.init('#' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '');
            if (options.getMode() === 'flash')
                videoEle = core.init('#' + constants.CSS_TOUCHCAST_FLASH_OVERLAY + '');
            //var ua = navigator.userAgent
            //event = (ua.match(/iPhone|iPod|iPad/i)) ? "touchstart" : "click";
            // event = "touchstart click";
            var event ='click';
            if (util.isiPad() || util.isiPhone()) {
                event = 'touchstart';
            } else {
                event = 'click';
            }
            core.off(videoEle, event);
            core.on(videoEle, event, function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                playerUI.hideDebugMenu();
                var curTime = self.getCurrentTime();
                if (options.isHls() && self.tcInside !== 1) {
                    if (!options.getHlsVod()) {
                        var pos = util.getClickPos(e, this, videoEle, options.isFullscreen(), 1);
                        if (self.hlsData !== '') {
                            if (options.getEncodingMechanism() === 'old') {
                                TouchCast.InteractiveLayer.setActions(self.hlsData, curTime, self.hlsUUID, self.hlsBaseUrlActions);
                            } else {
                                TouchCast.InteractiveLayer.setActions(self.hlsData, curTime, self.hlsUUID, self.hlsBaseUrlActions, 'xml');
                            }
                        }
                        //TouchCast.InteractiveLayer.notifyVideoIsLoaded(self.hlsDecimal);
                        TouchCast.InteractiveLayer.handleClicks(curTime, pos.xClick, pos.yClick);
                    } else {
                        var pos = util.getClickPos(e, this, videoEle, options.isFullscreen(), 1);
                        TouchCast.InteractiveLayer.handleClicks(curTime, pos.xClick, pos.yClick);
                    }
                } else {
                    var pos = util.getClickPos(e, this, videoEle, options.isFullscreen(), 1);
                }
                if (!options.isHls()) {
                    TouchCast.InteractiveLayer.handleClicks(curTime, pos.xClick, pos.yClick);
                }
            });
        },
        getSegmentsInfo: function() {
            var self = this;
            if (self.getHlsSource() !== '' && (options.getLivestreamState() === 'paused' || options.getLivestreamState() === 'finished')) {
                if (self.qualityFile === '') {
                    //logger.log(self.getHlsSource());
                    core.ajax({
                        type: 'get',
                        url: self.getHlsSource(),
                        dataType: "html",
                        success: function(data) {
                            var re = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
                            var result = re.exec(data);
                            if(result[2]){
                                var to = self.getHlsSource().lastIndexOf('/') + 1;
                                var baseUrl = self.getHlsSource().substring(0, to);
                                self.qualityFile = baseUrl + '' + result[2];
                                self.parseQualityFile();
                            }else{
                                self.qualityFile = self.getHlsSource();
                                self.parseQualityFile();
                            }
                        }
                    });
                } else {
                    self.parseQualityFile();
                }

            } else {
                self.safariAjax = 0;
            }
        },
        parseQualityFile: function() {
            var self = this;
            core.ajax({
                type: 'get',
                url: self.qualityFile,
                dataType: "html",
                success: function(data) {
                    // parse all ts info
                    var currentSN = 0,
                        totalduration = 0,
                        level = {
                            type: null,
                            version: null,
                            url: self.qualityFile,
                            fragments: [],
                            live: true,
                            startSN: 0
                        },
                        cc = 0,
                        prevFrag = null,
                        frag = {},
                        result,
                        i;
                    var segmentRegex = new RegExp([/#EXTINF:(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
                        /|(?!#)(\S+)/.source, // segment URI, group 3 => the URI (note newline is not eaten)
                        /|#EXT-X-BYTERANGE:*(.+)/.source, // next segment's byterange, group 4 => range spec (x@y)
                        /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, // next segment's program date/time group 5 => the datetime spec
                        /|#.*/.source // All other non-segment oriented tags will match with all groups empty
                    ].join(''), 'g');

                    var segmentRegexMoreInfo = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;

                    segmentRegex.lastIndex = 0;

                    while ((result = segmentRegex.exec(data)) !== null) {
                        var duration = result[1];
                        if (duration) {
                            // INF
                            frag.duration = parseFloat(duration);
                            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                            var title = (' ' + result[2]).slice(1);
                            frag.title = title ? title : null;


                        } else if (result[3]) {
                            // url
                            if (!isNaN(frag.duration)) {
                                var sn = currentSN++;
                                //frag.type = type;
                                frag.start = totalduration;
                                //frag.levelkey = levelkey;
                                frag.sn = sn;
                                //frag.level = id;
                                frag.cc = cc;
                                frag.baseurl = self.qualityFile;
                                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                                frag.relurl = (' ' + result[3]).slice(1);

                                self.segmentEnd[sn] = totalduration + frag.duration;

                                level.fragments.push(frag);
                                prevFrag = frag;
                                totalduration += frag.duration;
                                frag = {};
                            }
                        } else if (result[4]) {
                            // X-BYTERANGE
                            frag.rawByteRange = (' ' + result[4]).slice(1);
                            if (prevFrag) {
                                var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
                                if (lastByteRangeEndOffset) {
                                    frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
                                }
                            }
                        } else if (result[5]) {
                            // PROGRAM-DATE-TIME
                            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                            frag.rawProgramDateTime = (' ' + result[5]).slice(1);
                            frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
                            if (level.programDateTime === undefined) {
                                level.programDateTime = new Date(new Date(Date.parse(result[5])) - 1000 * totalduration);
                            }
                        } else {
                            result = result[0].match(segmentRegexMoreInfo);
                            for (i = 1; i < result.length; i++) {
                                if (result[i] !== undefined) {
                                    break;
                                }
                            }

                            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                            var value1 = (' ' + result[i + 1]).slice(1);
                            var value2 = (' ' + result[i + 2]).slice(1);

                            switch (result[i]) {
                                case '#':
                                    //frag.tagList.push(value2 ? [value1, value2] : [value1]);
                                    break;
                                case 'PLAYLIST-TYPE':
                                    level.type = value1.toUpperCase();
                                    options.setHlsPlaylistType(value1.toUpperCase());
                                    break;
                                case 'MEDIA-SEQUENCE':
                                    currentSN = level.startSN = parseInt(value1);
                                    break;
                                case 'TARGETDURATION':
                                    level.targetduration = parseFloat(value1);
                                    break;
                                case 'VERSION':
                                    level.version = parseInt(value1);
                                    break;
                                case 'EXTM3U':
                                    break;
                                case 'ENDLIST':
                                    level.live = false;
                                    break;
                                case 'DIS':
                                    cc++;
                                    //frag.tagList.push(['DIS']);
                                    break;
                                case 'DISCONTINUITY-SEQ':
                                    cc = parseInt(value1);
                                    break;
                                case 'KEY':
                                    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
                                    var decryptparams = value1;
                                    var keyAttrs = new attr_list(decryptparams);
                                    var decryptmethod = keyAttrs.enumeratedString('METHOD'),
                                        decrypturi = keyAttrs.URI,
                                        decryptiv = keyAttrs.hexadecimalInteger('IV');
                                    break;
                                case 'START':
                                    var startParams = value1;
                                    var startAttrs = new attr_list(startParams);
                                    var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
                                    //TIME-OFFSET can be 0
                                    if (!isNaN(startTimeOffset)) {
                                        level.startTimeOffset = startTimeOffset;
                                    }
                                    break;
                                case 'MAP':
                                    var mapAttrs = new attr_list(value1);
                                    frag.relurl = mapAttrs.URI;
                                    frag.rawByteRange = mapAttrs.BYTERANGE;
                                    frag.baseurl = self.qualityFile;
                                    frag.level = id;
                                    frag.type = type;
                                    frag.sn = 'initSegment';
                                    level.initSegment = frag;
                                    frag = {};
                                    break;
                                default:
                                    logger.log('line parsed but not handled: ' + result);
                                    break;
                            }
                        }
                    }
                    frag = prevFrag;
                    //logger.log('found ' + level.fragments.length + ' fragments');
                    if (frag && !frag.relurl) {
                        level.fragments.pop();
                        totalduration -= frag.duration;
                    }
                    level.totalduration = totalduration;
                    level.averagetargetduration = totalduration / level.fragments.length;
                    level.endSN = currentSN - 1;
                    level.startCC = level.fragments[0] ? level.fragments[0].cc : 0;
                    level.endCC = cc;
                    self.safariAjax = 0;

                }
            });
        },
        getHlsData: function() {
            var self = this;
            //var curTime = self.getCurrentTime();
            if (options.getEncodingMechanism() === 'old') {
                var decimal = playerUI.getDecimalHLS();
                if (decimal !== self.hlsDecimal) {
                    self.hlsDecimal = decimal;
                    var to = self.getHlsSource().lastIndexOf('/') + 1;
                    var baseUrl = self.getHlsSource().substring(0, to);
                    if (baseUrl.substr(-1) === '/') {
                        self.hlsBaseUrlActions = baseUrl.substr(0, baseUrl.length - 1);
                    }
                    var hlsSourceUrlSplit = self.getHlsSource().split('/');
                    self.hlsUUID = hlsSourceUrlSplit[hlsSourceUrlSplit.length - 2] + '' + self.hlsDecimal;;
                    var jSONURL = baseUrl + self.hlsDecimal + '.json';
                    logger.log('JSON Url for action data for livestream  -', jSONURL);
                    core.getJSON(jSONURL, function(data) {
                        self.hlsData = data;
                        var curTime = self.getCurrentTime();
                        if (self.tcInside !== 1 && self.hlsData !== '') {
                            TouchCast.InteractiveLayer.setActions(self.hlsData, curTime, self.hlsUUID, self.hlsBaseUrlActions);
                            TouchCast.InteractiveLayer.notifyVideoIsLoaded(self.hlsUUID);
                        }
                    });
                }
            } else {
                var layoutName = playerUI.getLayoutValue();
                if (layoutName) {
                    if (layoutName !== self.hlsDecimal) {
                        self.hlsDecimal = layoutName;
                        if (options.getLivestreamAssetUrl() === '' || options.getLivestreamAssetUrl() === null) {
                            var to = self.getHlsSource().lastIndexOf('/') + 1;
                            var baseUrl = self.getHlsSource().substring(0, to);
                            if (baseUrl.substr(-1) === '/') {
                                self.hlsBaseUrlActions = baseUrl.substr(0, baseUrl.length - 1);
                            }
                            var hlsSourceUrlSplit = self.getHlsSource().split('/');
                            var xmlUrl = baseUrl + self.hlsDecimal + '.xml';
                        } else {
                            if (options.getLivestreamAssetUrl().substr(-1) === '/') {
                                self.hlsBaseUrlActions = options.getLivestreamAssetUrl().substr(0, options.getLivestreamAssetUrl().length - 1);
                            }
                            var xmlUrl = options.getLivestreamAssetUrl() + self.hlsDecimal + '.xml';
                        }
                        //self.hlsUUID = hlsSourceUrlSplit[hlsSourceUrlSplit.length - 2] + '' + self.hlsDecimal;
                        self.hlsUUID = options.getLivestreamId() + '' + self.hlsDecimal;

                        logger.log('XML Url for action data for livestream -', xmlUrl);
                        core.ajax({
                            type: "GET",
                            url: xmlUrl,
                            dataType: "text",
                            success: function(xml) {
                                self.hlsData = xml;
                                var curTime = self.getCurrentTime();
                                if (self.tcInside !== 1 && self.hlsData !== '') {
                                    TouchCast.InteractiveLayer.setActions(self.hlsData, curTime, self.hlsUUID, self.hlsBaseUrlActions, 'xml');
                                    TouchCast.InteractiveLayer.notifyVideoIsLoaded(self.hlsUUID);
                                }
                            }
                        });

                    }
                }
            }
        },
        onFullScreenChange: function(fullscreen) {
            var fullscreenBtn = core.init('.' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + '');
            options.setFullscreen(fullscreen ? 1 : 0);
            //playerUI.toggleFullscreen(fullscreenBtn);
            if (util.isSafari()) {
                var chatInput = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + '');
                if (options.isFullscreen() === 1) {
                    if (!core.hasClass(chatInput, constants.CSS_TOUCHCAST_HIDE)) {
                        core.trigger(core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + ''), 'click');
                    }
                } else {
                    if (core.hasClass(chatInput, constants.CSS_TOUCHCAST_HIDE)) {
                        core.trigger(core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + ''), 'click');
                    }
                }
            }
            caption = language.getFullscreenExitTooltip();
            if (options.isFullscreen() === 1) {
                var caption = language.getFullscreenExitTooltip();
            } else {
                var caption = language.getFullscreenTooltip();
            }
            this._updateTooltipster(fullscreenBtn, caption);
            this.resize();
        },
        initFullScreen: function() {
            var self = this;
            var fullscreenBtn = core.init('.' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + '');
            if (util.isAndroid()) {
                var eventName = 'mousedown';
            } else {
                var eventName = 'touchstart click';
            }
            core.off(fullscreenBtn, eventName);
            core.on(fullscreenBtn, eventName, function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                playerUI.toggleFullscreen(core.init(this));
                self.resize();
            });
            var fsEvent = 'webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange';
            core.off(core.init(document), fsEvent);
            core.on(core.init(document), fsEvent, function(e) {
                var fsElem;
                switch (e.type) {
                    case 'fullscreenChange':
                        fsElem = document.fullscreenElement;
                        break;
                    case 'fullscreenchange':
                        fsElem = document.fullscreen;
                        break;
                    case 'webkitfullscreenchange':
                        fsElem = document.webkitIsFullScreen;
                        break;
                    case 'mozfullscreenchange':
                        fsElem = document.mozFullScreen;
                        break;
                    case 'MSFullscreenChange':
                        fsElem = document.msFullscreenElement;
                        break;
                }
                self.onFullScreenChange(fsElem);
            });
        },
        initVolumeControl: function() {
            var self = this;
            playerUI.initVolumeControl();
            var obj = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span');
            core.off(obj, 'click mouseup');
            core.on(obj, 'click mouseup', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.unmuteAudio();
                self.setVolume(core.init(this).index() + 1);
            });

            var obj = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + '');
            core.off(obj, 'mouseleave');
            core.on(obj, 'mouseleave', function(e) {
                e.stopImmediatePropagation();
                if (!playerUI.isMute())
                    self.setVolume(options.getVolume());
                else {
                    var bars = core.find(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ''), 'span');
                    core.removeClass(bars, constants.CSS_TOUCHCAST_ACTIVE);
                    core.removeClass(bars, constants.CSS_TOUCHCAST_MOUSE_ACTIVE);
                    playerUI.setVolumeLabelValue(0);
                }
            });
            core.off(obj, 'click');
            core.on(obj, 'click', function(e) {
                e.stopImmediatePropagation();
                self.setVolume(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_LABEL + '').text());
            });

            var obj = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ' .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + '');
            core.off(obj, 'click');
            core.on(obj, 'click', function(e) {
                e.stopImmediatePropagation();
                if (playerUI.isMute())
                    self.unmuteAudio();
                else
                    self.muteAudio();
                return false;
            });
        },
        getVolume: function() {
            return options.getVolume() / options.getMaxVolumeLevel();
        },
        changeVolume: function(val) {
            this.setVolume(Math.round(val * options.getMaxVolumeLevel()), true);
            this.setPlayerVolume(val);
        },
        setVolume: function(level, unmute) {
            var barLevel = level;
            if (level > options.getMaxVolumeLevel())
                level = options.getMaxVolumeLevel();

            var vol = level / options.getMaxVolumeLevel();
            this.setPlayerVolume(vol);
            if (options.getSound() && options.getSound() !== null && !options.getSoundIsEmpty()) {
                options.setSoundVolume(vol);
            }
            var bars = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span');
            if (barLevel >= options.getMaxVolumeLevel())
                core.addClass(bars, constants.CSS_TOUCHCAST_ACTIVE);
            else {
                core.removeClass(bars, constants.CSS_TOUCHCAST_ACTIVE);
                core.addClass(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span:eq(' + barLevel + ')'), constants.CSS_TOUCHCAST_ACTIVE);
            }

            options.setVolume(level);
            var bar = playerUI.updateVolume(level, unmute);
            playerUI.updateVolumeBarOnMouseActive(bar);
        },
        setPlayerVolume: function(vol) {
            options.setCurrentVolume(vol);
            var hasWebmVideo = (options.videoInfo[0].videoWebm) ? true : '';
            if (TouchCast.InteractiveLayer.getPlayerMode(hasWebmVideo) === 'html5') {
                core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].volume = vol;
            } else {
                options.getFlashMovie()['TouchCast.FlashSDK.Fallback.setVolume'](vol);
            }
            if (options.getSound() && options.getSound() !== null && !options.getSoundIsEmpty()) {
                if (options.getSoundVolume() && options.getSoundVolume() !== null) {
                    options.getSound().volume = vol * options.getSoundVolume();
                } else {
                    options.getSound().volume = vol;
                }
            }
        },
        muteAudio: function() {
            this.setPlayerVolume(0);
            playerUI.updateVolumeLabel(true);
            playerUI.setVolumeLabelValue(0);
        },
        unmuteAudio: function() {
            this.setVolume(options.getVolume(), true);
            if (options.getSound() && options.getSound() !== null && !options.getSoundIsEmpty() && options.getSoundVolume() && options.getSoundVolume() !== null) {
                options.getSound().volume = options.getCurrentVolume() * options.getSoundVolume();
            } else {
                options.getSound().volume = options.getCurrentVolume();
            }
        },
        onTimeUpdate: function(duration) {
            var self = this;
            var controls = this.controls;
            var curTime = self.getCurrentTime();
            var dur = options.getVideoDuration();
            if (curTime === 0 && self.insideChange === 1)
                return false;

            playerUI.showHidePoster(constants.CSS_TOUCHCAST_VIDEO_ELEMENT, 0);
            if (self.getProgressBarState() !== 0) {
                var percentage = (parseFloat(duration) / (options.getTotalDuration()));
                if (options.isLive()) {
                    controls.hasHours = (curTime / 3600) >= 1.0;
                }
                controls.currentTime.text(util.formatTime(curTime, controls.hasHours));
                if (options.isHls()) {
                    var percentage = 1;
                }
                var progress = curTime / dur;
                var progressPer = (Math.floor(progress * (controls.total.width() - (controls.progress.offset().left * 2))) / Math.floor((controls.total.width() - (controls.progress.offset().left * 2)))) * 100;
                if (util.getBrowser() === 'Trident' && self.fullscreen === 1)
                    progressPer = (Math.floor(progress * ((controls.total[0].getBoundingClientRect().width * 100) - (controls.progress.offset().left * 2))) / Math.floor(((controls.total[0].getBoundingClientRect().width * 100) - (controls.progress.offset().left * 2)))) * 100;
                controls.progress[0].style.width = progressPer * percentage + "%";
            }
            //call SDK Method
            TouchCast.InteractiveLayer.notifyVideoPlayTime(curTime);
            //transcript
            var transcriptions = playerUI.getTranscriptions();

            if (transcriptions && self.getTranscriptionsButtonState() === 1) {
                self.setTranscriptions(transcriptions, curTime);
            }
            if (typeof receiver !== 'undefined' && receiver !== null) {
                try {
                    receiver.emit('timeupdate', {
                        seconds: curTime,
                        duration: dur
                    });
                } catch (err) {
                    console.error(err);
                }
            }
            if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                try {
                    if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                        var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                    } else {
                        var originalInfo = '';
                    }
                    //TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.TIME_UPDATE, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '","time":"' + curTime + '"' + originalInfo + '}');
                } catch (err) {
                    console.error(err);
                }
            }
            if (options.isiPhonePlay()) {
                if (parseFloat(options.getAudio().currentTime) >= parseFloat(options.getTotalDuration())) {
                    if (!options.isLive()) {
                        options.getAudio().currentTime = 0;
                        events.triggerEvent(constants.EVENT_VIDEO_END);
                        if (self.hasEndScreen() !== 0) {
                            playerUI.showEndScreen();
                            this.currentTime = 0;
                        }
                        if (typeof receiver !== 'undefined' && receiver !== '') {
                            try {
                                receiver.emit('ended');
                            } catch (err) {
                                console.error(err);
                            }
                        }
                        if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                            try {
                                if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                                    var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                                } else {
                                    var originalInfo = '';
                                }
                                TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_ENDED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                            } catch (err) {
                                console.error(err);
                            }
                        }
                        if (self.getLoop() === 0)
                            self.pauseVideo(1);
                        else
                            self.resumeVideo();
                    }
                }
            }
            if (options.isHls()) {
                if (!options.getHlsVod()) {
                    if (util.checkIfLiveInteractivitySafariSupported()) {
                        self.getHlsData();
                    }
                    if (self.calledHostForPauseFinish === 0 && util.isSafari() && self.safariAjax === 0) {
                        self.safariAjax = 1;
                        self.getSegmentsInfo();
                    }
                }
                if (!options.getHlsVod()) {
                    if ((options.getLivestreamState() === 'paused' || options.getLivestreamState() === 'finished') && self.lastSegmentReceived !== '') {
                        var indexFromLastSegmentReceived = parseInt(self.lastSegmentReceived.replace(/[^\d]/g, ''));
                        if (self.segmentEnd[indexFromLastSegmentReceived] && (self.segmentEnd[indexFromLastSegmentReceived] <= (curTime + 1))) {
                            if (options.getLivestreamState() === 'paused') {
                                self.calledHostForPauseFinish = 1;
                                logger.log('Showing paused state')
                                self.liveStateCalled = 0;
                                interactiveLayerConfig.livestream_handler.reachedState('paused');
                                self.segmentEnd = [];
                                self.lastSegmentReceived = '';
                                /*if (self.isAutoPlayDisabledDevice()) {
                                    self.pauseVideo();
                                }*/
                                /*if(util.isSafari()){
                                    var vidElem = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                                    var vidSrcNode = core.find(vidElem, 'source');
                                    core.setAttr(vidSrcNode, 'src', '');
                                }*/
                                self.pauseVideo(1);
                            } else if (options.getLivestreamState() === 'finished' && (typeof(interactiveLayerConfig.livestream_data) === 'undefined')) {
                                self.calledHostForPauseFinish = 1;
                                self.hlsDecimal = '';
                                self.hlsData = '';
                                logger.log('Showing finished state');
                                interactiveLayerConfig.livestream_handler.reachedState('finished');
                                self.segmentEnd = [];
                            }
                        }
                    }
                }
                if (!util.isSafari()) {
                    var bufferHealth = self.hlsStatsData.bufferedTime - curTime;
                    if (bufferHealth < 1) {
                        bufferHealth = 0;
                    }
                    self.hlsStats.bufferHealth = bufferHealth;
                    options.updateHlsStats(self.hlsStats);
                }
            }

        },
        initTranscriptions: function(transcriptions) {
            var self = this;
            var transcriptionsBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_TRANSCRIPTIONS + '');

            if (transcriptions.transcriptionEnabled === 1) {
                core.addClass(transcriptionsBtn, constants.CSS_TOUCHCAST_SELECTED);
            }
            core.off(transcriptionsBtn, 'touchstart click');
            core.on(transcriptionsBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (transcriptions.transcriptionEnabled === 1) {
                    transcriptions.transcriptionEnabled = 0;
                    options.setDisableTranscription(true);
                    core.empty(core.init('.' + constants.CSS_TOUCHCAST_TRANSCRIPT + ''));
                    core.removeClass(transcriptionsBtn, constants.CSS_TOUCHCAST_SELECTED);
                    core.removeClass(transcriptionsBtn, constants.CSS_TOUCHCAST_ACTIVE);
                } else {
                    transcriptions.transcriptionEnabled = 1;
                    options.setDisableTranscription(false);
                    self.resetTranscriptions();
                    core.addClass(transcriptionsBtn, constants.CSS_TOUCHCAST_SELECTED);
                    core.addClass(transcriptionsBtn, constants.CSS_TOUCHCAST_ACTIVE);
                }
            });
        },
        initTranscriptionSelection: function(transcriptions) {
            var self = this;
            var languagesBtn = core.init('.' + constants.CSS_TOUCHCAST_LANGUAGES_LIST + '');
            core.off(languagesBtn, 'touch click');
            core.on(languagesBtn, 'touch click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var selected = core.init(this);
                core.removeClass(languagesBtn, constants.CSS_TOUCHCAST_LANGUAGES_SELECTED);
                core.addClass(selected, constants.CSS_TOUCHCAST_LANGUAGES_SELECTED);
                core.html(core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_SELECTED_LANG + ''), core.html(core.init('.' + constants.CSS_TOUCHCAST_LANGUAGES_SELECTED)));
                var type = core.getData(selected, 'subtitle');
                transcriptions.changeTranscriptions(type, self);
                setTimeout(function() {
                    var subtitlesPanelTitle = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_TITLE + '');
                    core.trigger(subtitlesPanelTitle, 'click');
                }, 300)
            });
        },
        resetTranscriptions: function() {
            var self = this;
            self.prevTranscriptIndex = -1;
            self.prevTranscriptTime = '';
            var transcriptEle = core.init('.' + constants.CSS_TOUCHCAST_TRANSCRIPT + '');
            core.empty(transcriptEle);
            //transcript
            var transcriptions = playerUI.getTranscriptions();
            var curTime = self.getCurrentTime();
            if (transcriptions) {
                self.setTranscriptions(transcriptions, curTime);
            }
        },
        setTranscriptions: function(transcriptions, curTime) {
            var self = this;
            var transcriptEle = core.init('.' + constants.CSS_TOUCHCAST_TRANSCRIPT + '');
            if (curTime <= self.prevTranscriptTime) {
                self.prevTranscriptIndex = -1;
                core.empty(transcriptEle);
            }
            for (transcript in transcriptions) {
                var transcriptLink = core.init('<p></p>');
                var openTime = parseFloat(transcriptions[transcript]['open_time']);
                var closeTime = parseFloat(transcriptions[transcript]['close_time']);
                var text = transcriptions[transcript]['text'];
                transcriptLink = transcriptLink.append(text);
                var text = core.init('<p>' + text + '</p>');
                var title = core.getAttr(text.find('a'), 'title');
                if (parseFloat(curTime) > openTime && parseFloat(curTime) < closeTime && parseFloat(self.prevTranscriptIndex) !== parseFloat(transcript) && playerUI.transcriptionEnabled() === 1) {
                    transcriptEle.append('<i><a></a></i>');
                    //transcriptEle.find('i a').append('<span> ' + title + '<i></i></span>');
                    transcriptEle.find('i a').append(transcriptLink);
                    self.prevTranscriptIndex = transcript;
                    self.prevTranscriptTime = openTime;
                } else if (parseFloat(curTime) > closeTime && parseFloat(self.prevTranscriptIndex) === parseFloat(transcript)) {
                    core.empty(transcriptEle);
                }
            }
        },
        onCanPlay: function() {
            var self = this;
            var controls = self.controls;
            var elPlayer = controls.video;
            setInterval(function() {
                util.writeCookie('TC' + options.videoInfo[options.getCurrentKey()].id, 'playing', 30);
            }, 30000);
            core.fadeOut(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''), 'fast');
            core.show(core.init('.' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ''));
            if (options.getOriginalTime(self.breadCrumbLevel) && options.getMode() === 'html5') {
                elPlayer[0].currentTime = options.getOriginalTime(self.breadCrumbLevel);
            }

            options.setChanging(0);
            logger.log('Ready to play');
            if (options.isHls()) {
                if (self.previousState === 'paused' && self.liveStateCalled === 0) {
                    logger.log('called reached state live');
                    interactiveLayerConfig.livestream_handler.reachedState('live');
                    self.liveStateCalled = 1;
                    self.resumeVideo();
                }
            }
            // call resize so that sdk has latest cordinates
            self.resize();
            if (core.getProp(elPlayer, 'is_playing'))
                return;

            if (options.isHls() && !options.isHlsSupported()) {
                logger.log('Safari HLS Livestream Duration ' + elPlayer[0].duration);
                if (elPlayer[0].duration == 'Infinity') {
                    options.setLive(true);
                    self.setLive();
                } else {
                    options.setLive(false);
                    self.disableLive();
                    options.setTotalDuration(elPlayer[0].duration);
                    options.setVideoDuration(elPlayer[0].duration);
                }

            }
            core.setProp(elPlayer, 'is_playing', true);
            self.setPlayerVolume(options.getCurrentVolume());
            if (self.insideChange !== 1 || options.videoInfo[options.getCurrentKey()].id === 'external') {
                //call SDK Method
                TouchCast.InteractiveLayer.notifyVideoIsLoaded(options.videoInfo[options.getCurrentKey()].id);
            }

            if (chapter.getChapterTime())
                self.setCurrentTime(chapter.getChapterTime());

            if (self.getStartTime() > options.getTotalDuration())
                self.setStartTime(0);
            if (chapter.getChapterClick() === 1) {
                self.resumeVideo();
                options.setClickPlay(0)
            } else if (self.getStartTime() > 0 && options.isEnded() === 0 && chapter.getChapterClick() !== 1) {
                /*setTimeout(function() {
                    controls.total.trigger(new core.Event('click', {
                        pageX: controls.total.width() * (self.getStartTime() / options.getTotalDuration())
                    }));
                }, 50);*/
                self.setCurrentTime(self.getStartTime());
            }
            if (self.getAutoPlay() === 1 && options.isEnded() === 0) {
                self.resumeVideo();
                options.setClickPlay(0);
            }
            self.doClickPlay();
            if (!options.isLive()) {
                self.updateDuration(controls);
            }
            self.handleProgressBar(controls.total);
            self.initTooltip();
            var doc = core.init(document);
            core.off(doc, 'keyup');
            core.on(doc, 'keyup', function(e) {
                if (e.keyCode === 32 && !options.isHls()) {
                    if (options.getPaused() !== 1)
                        self.pauseVideo(1);
                    else
                        self.resumeVideo();
                }
            });
            if (options.isiPhonePlay()) {
                playerUI.drawVideoFrame();
            }
        },
        getDuration: function() {
            return options.getVideoDuration();
        },
        updateDuration: function(controls) {
            controls.hasHours = (options.getVideoDuration() / 3600) >= 1.0;
            if (!options.isLive()) {
                controls['duration'].text(util.formatTime(options.getTotalDuration(), controls.hasHours));
            }
            controls.currentTime.text(util.formatTime(0), controls.hasHours);
            // playerUI._resizeProgressBar();
        },
        doClickPlay: function() {
            var self = this;
            logger.log('Do we have click to play enabled - ', options.getClickPlay());
            if (options.getClickPlay() === 1) {
                if ((self.isAutoPlayDisabledDevice()) && options.isHls()) {
                    if (util.isAndroid()) {
                        var eventName = 'mousedown';
                    } else if (util.isiPad() || util.isiPhone()) {
                        var eventName = 'touchstart';
                    } else {
                        var eventName = 'click';
                    }
                    core.one(options.elem, eventName, function(e) {
                        if (options.getClickPlay() !== 1)
                            return false;

                        logger.log('Click on Main Play Button');
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_POSTER + ''));
                        core.hide(core.init('.' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ''));

                        self.resumeVideo();
                        //return true;
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        self.resumeVideo();
                        options.setClickPlay(0);

                        return false;
                    });
                } else {
                    if (util.isAndroid()) {
                        var eventName = 'mousedown';
                    } else if (util.isiPad() || util.isiPhone()) {
                        var eventName = 'touchstart';
                    } else {
                        var eventName = 'click';
                    }
                    core.one(options.elem, eventName, function(e) {
                        if (options.getClickPlay() !== 1)
                            return false;

                        logger.log('Click on Main Play Button');
                        if (util.isiPad()) {
                            self.resumeVideo();
                            return true;
                        }
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        self.resumeVideo();
                        options.setClickPlay(0);
                        return false;
                    });
                }
            }
            if (options.getInteractiveTip() === true) {
                var tapOrClickNode = core.init('.' + constants.CSS_TOUCHCAST_TAP_OR_CLICK_CONTAINER + '');
                if (util.isAndroid()) {
                    var eventName = 'mousedown';
                } else if (util.isiPad() || util.isiPhone()) {
                    var eventName = 'touchstart';
                } else {
                    var eventName = 'click';
                }
                core.off(tapOrClickNode, eventName);
                core.on(tapOrClickNode, eventName, function(e) {
                    if (util.isiPad()) {
                        self.resumeVideo();
                        return true;
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    self.resumeVideo();
                    options.setClickPlay(0);
                    return false;
                });
            }
        },
        onPlay: function() {
            var controls = this.controls;
            if (typeof receiver !== 'undefined' && receiver !== '') {
                try {
                    receiver.emit('play');
                } catch (err) {
                    console.error(err);
                }
            }
            if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                try {
                    if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                        var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                    } else {
                        var originalInfo = '';
                    }
                    TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_PLAYED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                } catch (err) {
                    console.error(err);
                }
            }
            if (util.getFFVersion() >= 35 && this.getAutoPlay() !== 1 && this.initialLoad === true) {
                this.pauseVideo(1);
                this.initialLoad = false;
                return false;
            }
            options.setChanging(0);
            var self = this;
            /*if (self.getProgressBarState() != 0) {*/
            var intervalTime = 50;
            if (options.getMode() === 'flash')
                intervalTime = 300;

            if (options.progressInterval !== '')
                clearInterval(options.progressInterval);

            options.progressInterval = setInterval(function() {
                self.timeUpdateStartTime = Date.now();
                if (options.getPaused() !== 1 && options.isChanging() !== 1) {
                    self.onTimeUpdate(options.getVideoDuration());
                    // playerUI._resizeProgressBar();
                }
            }, intervalTime);
            /*}*/
            this.initialLoad = false;
            playerUI.updatePlayPauseButton(controls.playpause, 'play');
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_POSTER + ''));
            if (options.getInteractiveTip() === true) {
                var tapOrClickNode = core.init('.' + constants.CSS_TOUCHCAST_TAP_OR_CLICK_CONTAINER + '');
                core.fadeOut(tapOrClickNode, 'fast');
            }
            core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_VAPP_ICONS + ''), constants.CSS_TOUCHCAST_ACTIVE);
            if (this.hasEndScreen() !== 0)
                core.fadeOut(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_END_OVERLAY + ''));
            if (this.getAutoPlay() === 1) {
                if (options.getInteractiveTip() === true) {
                    core.delay(tapOrClickNode, 3000);
                    core.fadeOut(tapOrClickNode, 'fast');
                }
            } else {
                if (options.getInteractiveTip() === true) {
                    core.fadeOut(tapOrClickNode, 'fast');
                }
            }
            return false;
        },
        onPause: function() {
            if (typeof receiver !== 'undefined' && receiver !== '') {
                try {
                    receiver.emit('pause');
                } catch (err) {
                    console.error(err);
                }
            }
            if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                try {
                    if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                        var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                    } else {
                        var originalInfo = '';
                    }
                    TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_PAUSED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                } catch (err) {
                    console.error(err);
                }
            }
            if (options.progressInterval !== '')
                clearInterval(options.progressInterval);
            playerUI.updatePlayPauseButton(this.controls.playpause, 'pause');
            return false;
        },
        videoEnded: function() {
            events.triggerEvent(constants.EVENT_VIDEO_END);
            this.pauseVideo(1);
            options.setPaused(1);
            options.setEnded(1);
            options.setClickPlay(0);
            if (this.hasEndScreen() !== 0) {
                playerUI.showEndScreen();
            }
            if (typeof receiver !== 'undefined' && receiver !== '') {
                try {
                    receiver.emit('ended');
                } catch (err) {
                    console.error(err);
                }
            }
            if (typeof TouchCastPlayerAPI !== 'undefined' && TouchCastPlayerAPI !== '') {
                try {
                    if (typeof this.originalVideoInfo !== 'undefined' && this.originalVideoInfo && typeof this.originalVideoInfo[0] !== 'undefined' && this.originalVideoInfo[0] && typeof this.originalVideoInfo[0].id !== 'undefined' && this.originalVideoInfo[0].id && options.videoInfo[options.getCurrentKey()].id !== this.originalVideoInfo[0].id) {
                        var originalInfo = ',"originalVideoId":"' + this.originalVideoInfo[0].id + '"';
                    } else {
                        var originalInfo = '';
                    }
                    TouchCastPlayerAPI.Event.trigger(TouchCastPlayerAPI.VIDEO_ENDED, '{"videoId":"' + options.videoInfo[options.getCurrentKey()].id + '"' + originalInfo + '}');
                } catch (err) {
                    console.error(err);
                }
            }
            if (this.getLoop() === 0)
                this.pauseVideo(1);
            else
                this.resumeVideo();
        },
        updateProgressBar: function(pageX, obj) {
            var self = this;
            var controls = self.controls;

            if (self.getStartTime() === 0 || self.getAutoPlay() === 1)
                playerUI.showHidePoster(constants.CSS_TOUCHCAST_VIDEO_ELEMENT, 0);
            var x = (pageX - obj.offset().left) / (obj.width())
            if (util.getBrowser() === 'Trident' && self.fullscreen === 1)
                x = (pageX - (obj.offset().left)) / ((parseFloat(controls.total[0].getBoundingClientRect().width) * 100));
            if (options.isiPhonePlay()) {
                options.getAudio().currentTime = x * options.getTotalDuration();
                options.setPrevTime(Date.now());
                options.setPlaying(true);
                playerUI.videoTick();
                options.getAudio().play();
            }
            self.setCurrentTime(x * options.getTotalDuration());
        },
        handleProgressBar: function(obj) {
            var self = this;
            var controls = self.controls;
            core.off(obj, 'mousemove mouseleave touchmove touchstart touchend mousedown mouseup');
            core.on(obj, 'mousemove', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var x = (e.pageX - core.init(this).offset().left) / (core.getWidth(core.init(this)));
                if (x * 100 > 100)
                    return false;
                var durationGet = x * options.getTotalDuration();
                var hasHours = (options.getTotalDuration() / 3600) >= 1.0;
                playerUI.showTrackGuide(x * 100, util.formatTime(durationGet, hasHours));
                if (controls.isDragging)
                    self.updateProgressBar(e.pageX, core.init(this));
            });
            core.on(obj, 'mouseleave', function() {
                controls.isDragging = false;
                playerUI.hideTrackGuide();
            });
            core.on(obj, 'mousedown', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (options.isiPhonePlay()) {
                    options.getAudio().pause();
                    options.setPlaying(false);
                }
                controls.isDragging = true;
                self.updateProgressBar(e.pageX, core.init(this));
            });
            core.on(obj, 'mouseup', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (controls.isDragging) {
                    controls.isDragging = false;
                    self.updateProgressBar(e.pageX, core.init(this));
                }
            });
            core.on(obj, 'touchstart touchend touchmove', function(e) {
                if (options.isiPhonePlay()) {
                    options.getAudio().pause();
                    options.setPlaying(false);
                }
                var eventType = e.type === 'touchstart' ? 'mousedown' : e.type === 'touchend' ? 'mouseup' : e.type === 'touchmove' ? 'mousemove' : 'mouseup';

                var evnt = util.getTouchEvent(e);
                core.trigger(core.init(this), new core.Event(eventType, evnt));
                e.stopImmediatePropagation();
            });
        },
        onSeek: function() {
            var self = this;
            self.onTimeUpdate(options.getVideoDuration());
            if (!options.isiPhonePlay()) {
                options.setUserActive(0);
                playerUI.showLoading();
            }

        },
        onSeeked: function() {
            playerUI.hideTrackGuide();
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
            options.setUserActive(1);
            if (options.getPaused() !== 1) {
                var vappIcons = core.init('.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '.' + constants.CSS_TOUCHCAST_ACTIVE);
                if (vappIcons.length > 0 && !options.vappCloseTimer) {
                    options.vappCloseTimer = setTimeout(function() {
                        clearTimeout(options.vappCloseTimer);
                        options.vappCloseTimer = null;
                        core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_VAPP_ICONS + ''), constants.CSS_TOUCHCAST_ACTIVE);
                    }, 1000);
                }
            }
        },
        mute: function() {
            playerUI.updateVolume(options.getVolume(), false);
        },
        unmute: function() {
            playerUI.updateVolume(options.getVolume(), true);
        },
        setCurrentTime: function(time) {
            var self = this;
            options.setEnded(0);
            try {
                if (options.getMode() === 'html5') {
                    core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].currentTime = time;
                    if (options.isiPhonePlay()) {
                        options.getAudio().currentTime = time;
                    }
                } else {
                    var progressPer = time / options.getTotalDuration();
                    var flashMovie = options.getFlashMovie();
                    flashMovie["TouchCast.FlashSDK.Fallback.seekVideo"](progressPer);
                    self.controls.progress[0].style.width = (progressPer * 100) + "%";
                    self.onSeek();
                    self.controls.toLoad = progressPer;
                    self.pauseVideo(1);
                    self.controls.loadTimer = setInterval(function() {
                        var flashMovie = options.getFlashMovie();
                        var flashLoadProgress = flashMovie["TouchCast.FlashSDK.Fallback.getLoadingProgress"]();
                        logger.log('Flash Loaded Progress', flashLoadProgress);
                        logger.log('Flash Seek Value', self.controls.toLoad);
                        if (self.controls.toLoad <= flashLoadProgress) {
                            clearInterval(self.controls.loadTimer);
                            self.onSeeked();
                            self.resumeVideo();
                        }
                    }, 1000);
                }
            } catch (err) {
                console.error(err);
            }
            if (options.isiPhonePlay()) {
                playerUI.videoTick();
            }
        },
        getCurrentTime: function() {
            var self = this;
            if (options.getMode() === 'html5') {
                /*if (options.isHls()) {
                    return parseFloat(self.hlsCurrentTime) + parseFloat(core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].currentTime);

                } else {
                    return parseFloat(core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].currentTime);

                }*/
                return parseFloat(core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].currentTime);

            }
            var flashMovie = options.getFlashMovie();
            return flashMovie["TouchCast.FlashSDK.Fallback.getCurrentTime"]();
        },
        getPaused: function() {
            return options.getPaused() === 1 ? true : false;
        },
        getMuted: function() {
            return playerUI.isMute();
        },
        playSound: function(url, pauseWithVideo, volume) {
            options.getSound().src = url;
            options.setSoundIsEmpty(false);
            options.setSoundVolume(volume);
            options.setPauseWithVideo(pauseWithVideo);
            if (options.getSoundVolume() && options.getSoundVolume() !== null) {
                options.getSound().volume = options.getCurrentVolume() * options.getSoundVolume();
            } else {
                options.getSound().volume = options.getCurrentVolume();
            }
            options.getSound().addEventListener('ended', function() {
                this.currentTime = 0;
                this.load();
                this.play();
            }, false);
            options.getSound().load();
            options.getSound().play();
        },
        stopSound: function(url, pauseWithVideo) {
            if (options.getSound() && !options.getSoundIsEmpty()) {
                options.getSound().pause();
                //options.setSound(null);
                options.getSound().src = '';
                options.setSoundVolume(null);
                options.setPauseWithVideo(null);
                //options.setSound(new Audio());
                options.setSoundIsEmpty(true);
            }
        },
        stopAllSounds: function() {
            if (options.getSound() && !options.getSoundIsEmpty()) {
                options.getSound().pause();
                options.getSound().src = '';
                //options.setSound(null);
                options.setSoundVolume(null);
                options.setPauseWithVideo(null);
                //options.setSound(new Audio());
                options.setSoundIsEmpty(true);
            }
        },
        pauseVideo: function(fromUserAction) {
            logger.log('Pause Video');
            if (!options.isLive() || fromUserAction === 1) {
                //logger.log('Pause Video by User Action');
                if (options.getMode() === 'html5') {
                    if (options.isiPhonePlay()) {
                        options.getAudio().pause();
                        options.setPlaying(false);
                        playerUI.updatePlayPauseButton(this.controls.playpause, 'pause');
                    }
                    core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].pause();
                } else {
                    var flashMovie = options.getFlashMovie();
                    flashMovie["TouchCast.FlashSDK.Fallback.pauseVideo"]();
                    playerUI.updatePlayPauseButton(this.controls.playpause, 'pause');
                    this.onPause();
                }
                options.setPaused(1);
                if (options.getSound() && options.getSound() !== null && !options.getSoundIsEmpty()) {
                    options.getSound().pause();
                }
            }
        },
        resumeVideo: function(callback) {
            var self = this
            if (self.exitingPipMode) {
                return;
            }
            if (options.isEnded() === 1) {
                this.setCurrentTime(0);
                return false;
            }
            if (options.getMode() === 'html5') {
                if (options.isiPhonePlay()) {
                    options.setPrevTime(Date.now());
                    options.setPlaying(true);
                    playerUI.videoTick();
                    options.getAudio().play();
                    this.onPlay();
                    playerUI.updatePlayPauseButton(this.controls.playpause, 'play');
                } else
                    self.playPromise(core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + ''), callback);
            } else {
                var flashMovie = options.getFlashMovie();
                flashMovie["TouchCast.FlashSDK.Fallback.resumeVideo"]();
                playerUI.updatePlayPauseButton(this.controls.playpause, 'play');
                this.onPlay();
            }
            options.setPaused(0);
            if (options.getSound() && options.getSound() !== null) {
                options.getSound().play();
            }
        },
        toggleVideoPlayback: function() {
            if (options.getPaused() === 0) {
                this.pauseVideo(1);
            } else {
                this.resumeVideo();
            }
        },
        restartVideo: function(autoplay) {
            options.setClickPlay(0);
            this.setCurrentTime(0);
            options.setEnded(0);
            if (options.getMode() === 'html5' && options.isiPhonePlay()) {
                var audio = options.getAudio();
                audio.pause();
                options.setPlaying(false);
                audio.currentTime = 0;
            }
            if (autoplay) {
                this.resumeVideo();
            }

        },
        setLive: function() {
            var progress = core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
            core.addClass(progress, constants.CSS_TOUCHCAST_DISABLED);
            core.html(core.init('.' + constants.CSS_TOUCHCAST_DURATION_LABEL + ''), 'LIVE');
            core.addClass(core.init('.' + constants.CSS_TOUCHCAST_DURATION_LABEL + ''), 'tcLiveDuration');
            playerUI.hideProgressBar();
            //playerUI._resizeChat();
        },
        disableLive: function() {
            var progress = core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
            core.removeClass(progress, constants.CSS_TOUCHCAST_DISABLED);
            //core.html(core.init('.' + constants.CSS_TOUCHCAST_DURATION_LABEL + ''), 'LIVE');
            core.show(core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL + ''));
            core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_DURATION_LABEL + ''), 'tcLiveDuration');
            //playerUI._resizeChat();
        },
        disableControls: function(list, text) {
            if (list === 'all') {
                //var controls=core.init('.'+constants.CSS_TOUCHCAST_CONTROLS+'');
                var controls = core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + ', .' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + ', .' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
                core.addClass(controls, constants.CSS_TOUCHCAST_DISABLED);
                if (typeof text !== 'undefined' && text !== '') {
                    var contorlsWrapper = core.init('.' + constants.CSS_TOUCHCAST_CONTROLS + '').parent();
                    core.append(contorlsWrapper, '<div class="' + constants.CSS_TOUCHCAST_DISABLED_TEXT + '">' + text + '</div>');
                }
            } else {
                var list_array = list.split(',');
                for (var i = 0; i < list_array.length; i++) {
                    if (list_array[i] === 'play-pause') {
                        var playpause = core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + '');
                        core.addClass(playpause, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'progress-bar') {
                        var progress = core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
                        core.addClass(progress, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'recast') {
                        var recast = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
                        core.addClass(recast, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'share') {
                        var share = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '');
                        core.addClass(share, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'comment') {
                        var comment = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '');
                        core.addClass(comment, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'volume') {
                        var volume = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + '');
                        core.addClass(volume, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'info') {
                        var info = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '');
                        core.addClass(info, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'fullscreen') {
                        var fullscreen = core.init('.' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + '');
                        core.addClass(fullscreen, constants.CSS_TOUCHCAST_DISABLED);
                    }
                }
            }
        },
        enableControls: function(list) {
            if (list === 'all') {
                var controls = core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + ', .' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + ', .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + ', .' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
                core.removeClass(controls, constants.CSS_TOUCHCAST_DISABLED);
                core.remove(core.init('.' + constants.CSS_TOUCHCAST_DISABLED_TEXT + ''));
            } else {
                var list_array = list.split(',');
                for (var i = 0; i < list_array.length; i++) {
                    if (list_array[i] === 'play-pause') {
                        var playpause = core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + '');
                        core.removeClass(playpause, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'progress-bar') {
                        var progress = core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_CONTAINER + ', .' + constants.CSS_TOUCHCAST_TIMECODE + ',.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
                        core.removeClass(progress, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'recast') {
                        var recast = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
                        core.removeClass(recast, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'share') {
                        var share = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '');
                        core.removeClass(share, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'comment') {
                        var comment = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '');
                        core.removeClass(comment, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'volume') {
                        var volume = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + '');
                        core.removeClass(volume, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'info') {
                        var info = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '');
                        core.removeClass(info, constants.CSS_TOUCHCAST_DISABLED);
                    } else if (list_array[i] === 'fullscreen') {
                        var fullscreen = core.init('.' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + '');
                        core.removeClass(fullscreen, constants.CSS_TOUCHCAST_DISABLED);
                    }
                }
            }
        },

        clickedVapp: function(data) {
            var loadedData = core.parseJSON(data);
            if (loadedData) {
                options.setVappMode(loadedData.vapp_open_mode);
                if (loadedData.vapp_open_mode === 'pip')
                    options.setVappType(loadedData.type);
                else
                    options.setVappType('');
            }
        },
        filterCallbackUrl: function(vAppUrl, callback) {
            var extension = vAppUrl.substr(vAppUrl.lastIndexOf('.') + 1)
            callback(vAppUrl);
        },
        resizeAndroidProgressPanel: function() {
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL + ''), {
                width: '-webkit-calc(100% - ' + (core.getWidth(core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RIGHT_CONTAINER)) + 44) + 'px)'
            });
        },
        enteredPIPMode: function() {
            var type = options.getVappType();
            var mainContainer = core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + '');
            core.addClass(mainContainer, constants.CSS_TOUCHCAST_PIP_MODE);
            if (type === 'html' && util.getIEVersion() && util.getIEVersion() > 8) {
                core.remove(core.init('.' + constants.CSS_TOUCHCAST_BLANK_IFRAME + ''));
                var blankIframe = core.init('<iframe allowtransparency="true" frameborder="0"></iframe>');
                core.addClass(blankIframe, constants.CSS_TOUCHCAST_ABS_FIT_SCREEN);
                core.addClass(blankIframe, constants.CSS_TOUCHCAST_BLANK_IFRAME);
                core.setAttr(blankIframe, 'src', 'about:blank');
                core.append(mainContainer, blankIframe);
            }
            var thumbs = core.init('.' + constants.CSS_TOUCHCAST_FLYING_THUMBS_ICON + '');
            if(thumbs) {
              for (var i = 0; i < thumbs.length; i++) {
                core.remove(thumbs[i])
              }
            }
            if (util.getIEVersion() < 9) {
                var iframeBg = '';
                if (type === 'image') {
                    iframeBg = '#FFFFFF';
                    core.remove(core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ' div.img'));
                } else {
                    if (core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ' div.img').length < 1)
                        core.append(core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ''), '<div class="img"><div></div></div>');

                    var img = core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ' div.img div');
                    var imgBlur = core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ' div.img');
                    core.addClass(img, constants.CSS_TOUCHCAST_ABS_FIT_SCREEN);
                    core.addClass(imgBlur, constants.CSS_TOUCHCAST_ABS_FIT_SCREEN);

                    var thumb = this.originalVideoInfo[0].thumb;

                    core.setCss(img, {
                        'filter': "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + thumb + "', sizingMethod='scale')",
                        '-ms-filter': "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + thumb + "', sizingMethod='scale')"
                    });

                    core.setCss(imgBlur, {
                        'filter': "progid:DXImageTransform.Microsoft.Blur(Strength=2)",
                        '-ms-filter': "progid:DXImageTransform.Microsoft.Blur(Strength=2)",
                        'z-index': -1
                    });
                }
                core.setCss(core.init('.' + constants.CSS_TOUCHCAST_BROWSER + ' iframe'), {
                    'background': iframeBg
                });
            }

            playerUI._resize();
        },
        exitedPIPMode: function() {
            var self = this;
            var mainContainer = core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + '');
            self.exitingPipMode = true;
            core.removeClass(mainContainer, constants.CSS_TOUCHCAST_PIP_MODE);
            core.removeClass(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + ''), constants.CSS_TOUCHCAST_HIDE);
            core.addClass(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + ''), 'exitedPIPMode');
            if (util.getIEVersion() < 10) {
                core.init('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').height('');
                setTimeout(function() {
                    self.resize();
                }, 5);
            } else {
                if (options.isiPhonePlay() && (window.innerHeight > window.innerWidth)) {
                    var iphoneCanvas = core.init('#' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '');
                    core.hide(iphoneCanvas);
                    setTimeout(function() {
                        var iphoneCanvas = core.init('#' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '');
                        core.show(iphoneCanvas);
                        self.resize();
                    }, 1);
                }

                core.one(mainContainer, 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    self.resize();
                    if (util.getBrowser() === 'Trident' || util.getIEVersion() !== undefined){
                        setTimeout(function() {
                            self.resize();
                        }, 1000);
                    }
                });
            }
            setTimeout(function () {
                self.exitingPipMode = false;
                self.resumeVideo();
            }, 750);
        },
        playPromise: function(video, callback) {
          var promise = video[0].play();
          var self = this;
          if (promise !== undefined) {
            promise.then(function(){
                self.onPlay();
                if(callback){
                    callback();
                }
            }).catch(function(error) {
                if (video[0].paused) {
                    core.show(core.init('.' + constants.CSS_TOUCHCAST_POSTER + ''));
                }
            });
          }
        },
        iosAudio: function() {
            var self = this;
            if (options.visibilityChange !== '') {
                document.addEventListener(options.visibilityChange, function() {
                    if (document[options.hidden]) {
                        self.pauseVideo(1);
                    } else {
                        self.resumeVideo();
                    }
                }, false);
            }
        },
        // get video width
        getVideoAreaWidth: function() {
            // check if video element exits or else use the main element dimension
            if (options.getVideo().length && !options.isiPhonePlay()) {
                return options.getVideo().width();
            } else {
                return options.elem.width();
            }
        },
        // get video height
        getVideoAreaHeight: function() {
            // check if video element exits or else use the main element dimension
            if (options.getVideo().length && !options.isiPhonePlay()) {
                return options.getVideo().height();
            } else {
                return options.elem.height();
            }
        },
        // get video x offset
        getVideoAreaX: function() {
            // check if video element exits or else use the main element dimension
            if (options.getVideo().length && !options.isiPhonePlay()) {
                return options.getVideo().offset().left - options.elem.offset().left;
            } else {
                return options.elem.position().left;
            }
        },
        // get video y offset
        getVideoAreaY: function() {
            // check if video element exits or else use the main element dimension
            if (options.getVideo().length && !options.isiPhonePlay()) {
                return options.getVideo().offset().top - options.elem.offset().top;
            } else {
                return options.elem.position().top;
            }
        },
        //get touchcast id
        getTouchCastId: function() {
            return this.touchcastID;
        },
        //set touchcast id
        setTouchCastId: function(id) {
            this.touchcastID = id;
        },
        //get auto play
        getAutoPlay: function() {
            return this.autoplay;
        },
        //set auto play
        setAutoPlay: function(val) {
            this.autoplay = val;
        },
        //get loop
        getLoop: function() {
            return this.loop;
        },
        //set loop
        setLoop: function(val) {
            this.loop = val;
        },
        //has end screen
        hasEndScreen: function() {
            return this.end;
        },
        //set end screen
        setEndScreen: function(val) {
            this.end = val;
        },
        //has pdf enhancements
        hasPdfEnhancements: function() {
            return this.pdfEnhancements;
        },
        //set pdf enhancements
        setPdfEnhancements: function(val) {
            this.pdfEnhancements = val;
        },
        //get start time
        getStartTime: function() {
            return this.startTime;
        },
        //set start time
        setStartTime: function(time) {
            this.startTime = time;
        },
        //get state of play button
        getPlayButtonState: function() {
            return this.btnPlay;
        },
        //set state of play button
        setPlayButtonState: function(state) {
            this.btnPlay = state;
        },
        //get state of volume button
        getVolumeButtonState: function() {
            return this.btnVolume;
        },
        //set state of volume button
        setVolumeButtonState: function(state) {
            this.btnVolume = state;
        },
        //get state of progress bar
        getProgressBarState: function() {
            return this.tcProgressBar;
        },
        //set state of progress bar
        setProgressBarState: function(state) {
            this.tcProgressBar = state;
        },
        //get state of player time
        getPlayerTimeState: function() {
            return this.tcPlayerTime;
        },
        //set state of player time
        setPlayerTimeState: function(state) {
            this.tcPlayerTime = state;
        },
        //get state of recast button
        getRecastButtonState: function() {
            return this.btnReCast;
        },
        //set state of recast button
        setRecastButtonState: function(state) {
            this.btnReCast = state;
        },
        //get state of comment button
        getCommentButtonState: function() {
            return this.btnComment;
        },
        //set state of comment button
        setCommentButtonState: function(state) {
            this.btnComment = state;
        },
        //get state of chat button
        getChatButtonState: function() {
            return this.btnChat;
        },
        //set state of chat button
        setChatButtonState: function(state) {
            this.btnChat = state;
        },
        //get state of Search button
        getSearchButtonState: function() {
            return this.btnSearch;
        },
        //set state of Search button
        setSearchButtonState: function(state) {
            this.btnSearch = state;
        },
        //get state of thumbs button
        getThumbsButtonState: function() {
            return this.btnThumb;
        },
        //set state of thumbs button
        setThumbsButtonState: function(state) {
            this.btnThumb = state;
        },
        //get state of live button
        getLiveButtonState: function() {
            return this.btnLive;
        },
        //set state of live button
        setLiveButtonState: function(state) {
            this.btnLive = state;
        },
        //get state of settings button
        getSettingsButtonState: function() {
            return this.btnSettings;
        },
        //set state of settings button
        setSettingsButtonState: function(state) {
            this.btnSettings = state;
        },
        //get state of Transcriptions button
        getTranscriptionsButtonState: function() {
            return this.btnTranscriptions;
        },
        //set state of Transcriptions button
        setTranscriptionsButtonState: function(state) {
            this.btnTranscriptions = state;
        },
        //get state of info button
        getInfoButtonState: function() {
            return this.btnInfo;
        },
        //set state of info button
        setInfoButtonState: function(state) {
            this.btnInfo = state;
        },
        //get state of share button
        getShareButtonState: function() {
            return this.btnShare;
        },
        //set state of share button
        setShareButtonState: function(state) {
            this.btnShare = state;
        },
        //get state of fullscreen button
        getFullScreenButtonState: function() {
            return this.btnFullScreen;
        },
        //set state of fullscreen button
        setFullScreenButtonState: function(state) {
            this.btnFullScreen = state;
        },
        //get state of info box counters
        getInfoBoxCountersState: function() {
            return this.infoBoxShareViewsRecastCounts;
        },
        //set state of info box counters
        setInfoBoxCountersState: function(state) {
            this.infoBoxShareViewsRecastCounts = state;
        },
        //get state of info box bookmark button
        getInfoBoxBookmarkButtonState: function() {
            return this.infoBoxBookmarkButton;
        },
        //set state of info box bookmark button
        setInfoBoxBookmarkButtonState: function(state) {
            this.infoBoxBookmarkButton = state;
        },
        //get state of info box follow button
        getInfoBoxFollowButtonState: function() {
            return this.infoBoxFollowButton;
        },
        //set state of info box follow button
        setInfoBoxFollowButtonState: function(state) {
            this.infoBoxFollowButton = state;
        },
        //get state of info box flag button
        getInfoBoxFlagButtonState: function() {
            return this.infoBoxFlagButton;
        },
        //set state of info box flag button
        setInfoBoxFlagButtonState: function(state) {
            this.infoBoxFlagButton = state;
        },
        //is ajax allowed
        isAjaxAllowed: function() {
            return this.allowAjax;
        },
        //set ajax allowed state
        setAjaxAllowedState: function(state) {
            this.allowAjax = state;
        },
        //set Hls
        setHlsSource: function(hls) {
            this.hls = hls;
        },
        //get Hls
        getHlsSource: function(hls) {
            return this.hls;
        },
        // get version
        getVersion: function() {
            return mainConfig.version;
        },
        errorActionsXML: function() {
            playerUI.showError();
        },
        tcInTcLoadError: function() {
            playerUI.showNotificationError('Oops! Something went wrong and we can\'t load this TC inside TC vApp. Try again later.');
            this.resumeVideo();
        },
        isAutoPlayDisabledDevice: function() {
            if (util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid() || (util.isSafari() && util.getSafariVersion() >= 11)) {
                return true;
            } else {
                return false;
            }
        },
        END_VIDEO: constants.EVENT_VIDEO_END
    }
});

